import { Directive, ElementRef, Inject, Injector, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSelect } from "@angular/material/select";
import { CommonService, MasterserviceService, ProductserviceService, StorageService, StoreService, SurveyServiceService } from "@insite-store360/services";
import { noDataFound } from '@insite-store360/shared';
import { AddMasterUserComponent } from 'frontend-apps/insitestore360/src/app/module/master-management/add-master-user/add-master-user.component';
import { ADMIN_ROLE_ID, BA_ADMIN,
  SUPER_BA_ADMIN, BA_VIEW, CA_ANALYST_ROLE_ID, CA_TRAINER, CA_VIEW, COUNTRYPIC_ROLE_ID, FIELD_WORKER_GROUP_ROLES, LEVEL_3_GROUP_ROLES, LEVEL_4_GROUP_ROLES, LEVEL_6_GROUP_ROLES, PROMOTER_ROLE_ID, SALES, SALES_DIRECTOR_GM, SALES_LEVEL_GROUP_ROLES, SALES_MANAGER, TDL_ROLE_ID, TDS_EQUIVALENT_ROLE_ID, TDS_ROLE_ID, TRAINER_TDS_TDL_PROMOTER_ROLES, isTdsEquivalentRole } from 'library/api-common/src/lib/utils/appliationConstants';
import { UserServiceService } from "library/services/user-service.service";
import { ToastrService } from "ngx-toastr";
import { defaultIfEmpty, EMPTY, firstValueFrom, forkJoin, Observable, of, tap, timer } from "rxjs";
import { catchError, map } from "rxjs/operators";
import {
    DEFAULT_PROJECT_MANAGEMENT_ROLE_ID,
    PROJECT_MANAGEMENT_ROLE_OPTIONS,
} from '../../utils/project-management-role.util';
import { askTestSurveyRecordsAction } from '../../utils/test-survey-records.util';

interface LoadResults {
    countryFilter: any;
    storeNames: any;
    tdsData: any;
    storeIds?: number[];
    tdsIds?: number[];
}

@Directive()
export abstract class UserManagement {

    @ViewChild('search') searchTextBox!: ElementRef;
    @ViewChild('select') select!: MatSelect;
    tomorrow = new Date();
    public allSelected = false;
    public masterUserForm!: FormGroup;
    public userTypeValue: any[] = [];
    public countryCodeData: any[] = [];
    public roleSelection: any[] = [];
    public regionValue: any[] = [];
    public genderValue: string[] = ['Male', 'Female'];
    public managerCountryValue: any[] = [];
    public submitted: boolean = false;
    public formFieldDetails: any[] = [];
    public regionCheck: boolean = false;
    public loadingSpinner: boolean = false;
    public noDataFound: string = noDataFound;
    public userId: number[] = [];
    public userDetials: any;
    public storeNameDetails: any[] = [];
    public isLoading: boolean = false;
    public tdsDetails: any[] = [];
    public tdlDetails: any[] = [];
    private isMultiReportingManagerForPromoter: boolean = false;
    public regionUpdateDataCheck: boolean = false;
    public tierValue: number = 0
    public promoterTypeValueCheck: boolean = false;
    public showProjectManagementToggle: boolean = false;
    private editPmAccessSnapshot: boolean | null = null;
    private editPmRoleSnapshot: number | null = null;
    private editIsTestUserSnapshot = false;
    public readonly projectManagementRoleOptions = PROJECT_MANAGEMENT_ROLE_OPTIONS;
    public pmAccessOnlyMode = false;
    public grantPmAccessMode = false;
    public embeddedInline = false;
    public loggedInUserRoles: any[] = []; // Store logged-in user's roles with projectId
    public loggedInUserProjectId: number | null = null; // Store logged-in user's projectId
    public loggedInUserRegionDetails: number[] = []; // Store logged-in user's assigned region IDs
    public adminForm: any[] = [
        {
            title: 'Region*',
            formControlName: 'regionId',
            placeHolder: 'Select Region',
            autoFetchFieldName: 'Region',
            multiselect: true,
            allSelected: false,
            visible: true,
            filteredValues: [],
            searchQuery: '',
            value: [],
        },
        {
            title: 'Country*',
            formControlName: 'countryId',
            placeHolder: 'Select Country',
            multiselect: true,
            allSelected: false,
            visible: true,
            searchQuery: '',
            value: [],
        },
    ];
    public baForm: any[] = [
        {
            title: 'Region*',
            formControlName: 'regionId',
            placeHolder: 'Select Region',
            autoFetchFieldName: 'Region',
            multiselect: true,
            allSelected: false,
            visible: true,
            searchQuery: '',
            value: [],
        },
        {
            title: 'Country*',
            formControlName: 'countryId',
            placeHolder: 'Select Country',
            multiselect: true,
            allSelected: false,
            visible: true,
            searchQuery: '',
            value: [],
        },
    ];
    public regionalHeadForm: any[] = [
        {
            title: 'Region*',
            formControlName: 'regionId',
            placeHolder: 'Select Region',
            autoFetchFieldName: 'Region',
            multiselect: true,
            allSelected: false,
            visible: true,
            searchQuery: '',
            value: [],
        },
        {
            title: 'Country*',
            formControlName: 'countryId',
            placeHolder: 'Select Country',
            multiselect: true,
            allSelected: false,
            visible: true,
            searchQuery: '',
            value: [],
        },
    ];
    public regionalAnalystForm: any[] = [
        {
            title: 'Region*',
            formControlName: 'regionId',
            placeHolder: 'Select Region',
            autoFetchFieldName: 'Region',
            multiselect: true,
            allSelected: false,
            visible: true,
            searchQuery: '',
            value: [],
        },
        {
            title: 'Country*',
            formControlName: 'countryId',
            placeHolder: 'Select Country',
            multiselect: true,
            allSelected: false,
            visible: true,
            searchQuery: '',
            value: [],
        },
    ];
    public countryPICForm: any[] = [
        {
            title: 'Region*',
            formControlName: 'regionId',
            placeHolder: 'Select Region',
            autoFetchFieldName: 'countryRegion',
            multiselect: false,
            visible: true,
            searchQuery: '',
            value: [],
        },
        {
            title: 'Country*',
            formControlName: 'countryId',
            placeHolder: 'Select Country',
            multiselect: false,
            visible: true,
            searchQuery: '',
            value: [],
        },
    ];
    public projectManagementForm: any[] = [
        {
            title: 'Region*',
            formControlName: 'regionId',
            placeHolder: 'Select Region',
            autoFetchFieldName: 'Region',
            multiselect: true,
            allSelected: false,
            visible: true,
            filteredValues: [],
            searchQuery: '',
            value: [],
        },
        {
            title: 'Country*',
            formControlName: 'countryId',
            placeHolder: 'Select Country',
            multiselect: true,
            allSelected: false,
            visible: true,
            searchQuery: '',
            value: [],
        },
    ];
    public tdsForm: any[] = [
        {
            title: 'Region*',
            formControlName: 'regionId',
            placeHolder: 'Select Region',
            autoFetchFieldName: 'Region',
            multiselect: false,
            visible: false,
            searchQuery: '',
            value: [],
        },
        {
            title: 'Country*',
            formControlName: 'countryId',
            placeHolder: 'Select Country',
            autoFetchFieldName: 'countryStore',
            multiselect: false,
            visible: true,
            searchQuery: '',
            value: [],
        },

        {
            title: 'Store Name*',
            formControlName: 'storeIds',
            placeHolder: 'Select Store',
            multiselect: true,
            allSelected: false,
            visible: true,
            searchQuery: '',
            value: [],
        },
        {
            title: 'Select TDL',
            formControlName: 'tdsReportingManager',
            placeHolder: 'Select TDL',
            multiselect: true,
            allSelected: false,
            visible: true,
            autoFetchFieldName: 'tdlByCountry',
            searchQuery: '',
            value: [],
        },
        {
            title: 'Login ID*',
            formControlName: 'loginId',
            placeHolder: 'Login ID',
            multiselect: false,
            allSelected: false,
            visible: true,
            searchQuery: '',
            value: [],
        },

    ];
    public promoterForm: any[] = [
        {
            title: 'Region*',
            formControlName: 'regionId',
            placeHolder: 'Select Region',
            autoFetchFieldName: 'Region',
            multiselect: false,
            visible: false,
            searchQuery: '',
            value: [],
        },
        {
            title: 'Country*',
            formControlName: 'countryId',
            placeHolder: 'Select Country',
            autoFetchFieldName: 'countryStore',
            multiselect: false,
            visible: true,
            searchQuery: '',
            value: [],
        },
        {
            title: 'Store Name*',
            formControlName: 'storeIds',
            placeHolder: 'Select Store',
            multiselect: true,
            allSelected: false,
            visible: true,
            searchQuery: '',
            value: [],
        },
        {
            title: 'Select TDS/TDL*',
            formControlName: 'promotertds',
            placeHolder: 'Select TDS/TDL',
            multiselect: true,
            allSelected: false,
            visible: true,
            searchQuery: '',
            value: [],
        },
        {
            title: 'Basic Pay*',
            formControlName: 'basicSalary',
            placeHolder: 'Basic Pay',
            multiselect: false,
            allSelected: false,
            visible: true,
            searchQuery: '',
            value: [],
        },
        {
            title: 'Tier',
            formControlName: 'tiers',
            placeHolder: 'Select Tier',
            autoFetchFieldName: 'tierCheck',
            multiselect: false,
            allSelected: false,
            visible: true,
            searchQuery: '',
            value: [],
        },
        {
            title: 'Incentive Scheme',
            formControlName: 'incentiveSchemeTypeId',
            placeHolder: 'Select Incentive Scheme',
            autoFetchFieldName: 'IncentiveSchemeType',
            multiselect: false,
            allSelected: false,
            visible: true,
            searchQuery: '',
            value: [],
        },
        {
            title: 'Promoter Category',
            formControlName: 'mdaSdaCountryId',
            placeHolder: 'Select Promoter Category',
            autoFetchFieldName: 'mdaSdaCountry',
            multiselect: false,
            allSelected: false,
            visible: true,
            searchQuery: '',
            value: [],
        },
        {
            title: 'Login ID*',
            formControlName: 'loginId',
            placeHolder: 'Login ID',
            multiselect: false,
            allSelected: false,
            visible: true,
            searchQuery: '',
            value: [],
        },
        {
            title: 'Promoter Type',
            formControlName: 'promoterType',
            placeHolder: 'Select Promoter Type',
            multiselect: false,
            allSelected: false,
            visible: true,
            searchQuery: '',
            value: [],
        },
    ];

    firstName: any;
    lastName: any;
    getUserRole: any;

    protected masterFB: FormBuilder;
    protected commonService: CommonService;
    protected storage: StorageService;
    protected masterService: MasterserviceService;
    protected storeService: StoreService;
    protected userService: UserServiceService;
    protected productService: ProductserviceService;
    protected surveyService: SurveyServiceService;
    protected toastr: ToastrService;
    protected dialogRef: MatDialogRef<AddMasterUserComponent>;
    protected matDialog: MatDialog;

    constructor(protected injector: Injector,
        @Inject(MAT_DIALOG_DATA) public editData: any
    ) {
        this.masterFB = injector.get(FormBuilder);
        this.commonService = injector.get(CommonService);
        this.storage = injector.get(StorageService);
        this.masterService = injector.get(MasterserviceService);
        this.storeService = injector.get(StoreService);
        this.userService = injector.get(UserServiceService);
        this.productService = injector.get(ProductserviceService);
        this.surveyService = injector.get(SurveyServiceService);
        this.toastr = injector.get(ToastrService);
        this.dialogRef = injector.get(MatDialogRef);
        this.matDialog = injector.get(MatDialog);
    }

    init(): void {
        this.pmAccessOnlyMode = this.editData?.pmAccessOnlyMode === true;
        this.grantPmAccessMode = this.editData?.grantPmAccessMode === true;
        this.embeddedInline = this.editData?.embeddedInline === true;
        this.userForms();
        this.getCountryCode();
        let getId = this.storage.fetchdata('id');
        this.getUserRole = this.storage.fetchdata('roleDetails');
        if (this.editData) {
            this.isLoading = true;
            // First get logged-in user details to check projectId, then get user being edited details
            this.getLoginUserDetials(getId, 'editUserData', this.getUserRole);
        } else {
            this.editPmAccessSnapshot = null;
            this.editPmRoleSnapshot = null;
            this.getLoginUserDetials(getId, 'loginUser')
        }

    }

    getPromoterType() {
        this.userService.getPromoterType().subscribe((res) => {
            const field = this.promoterForm.find((f: any) => f.formControlName === 'promoterType');
            if (field) field.value = res.result || [{ id: 1, name: noDataFound }];
        });
    }

    getIncentiveSchemeTypes() {
        this.userService.getIncentiveSchemeTypes().subscribe((res) => {
            const field = this.promoterForm.find((f: any) => f.formControlName === 'incentiveSchemeTypeId');
            const list = res?.result?.result ?? res?.result ?? [];
            if (field) field.value = Array.isArray(list) ? list : [];
        });
    }

    loadMdaSdaCountryList(countryId: number | number[] | null | undefined) {
        const countryIds = countryId == null
            ? []
            : (Array.isArray(countryId) ? countryId.filter(Boolean) : [countryId]);
        const mdaSdaField = this.promoterForm.find((f: any) => f.formControlName === 'mdaSdaCountryId');

        if (countryIds.length === 0) {
            if (mdaSdaField) {
                mdaSdaField.value = [{ id: 1, name: this.noDataFound }];
            }
            return of([]);
        }

        return this.surveyService.getMdaSdaCountryList(countryIds).pipe(
            map((res: any) => {
                const list = res?.result ?? res ?? [];
                const options = Array.isArray(list) && list.length > 0
                    ? list
                    : [{ id: 1, name: this.noDataFound }];
                if (mdaSdaField) {
                    mdaSdaField.value = options;
                }
                return Array.isArray(list) ? list : [];
            }),
            catchError(() => {
                if (mdaSdaField) {
                    mdaSdaField.value = [{ id: 1, name: this.noDataFound }];
                }
                return of([]);
            }),
        );
    }

    private resolveMdaSdaCountryId(mobileUserData: any, mdaSdaList: any[]): number | null {
        if (!mobileUserData) {
            return null;
        }

        const existingId = mobileUserData.mdaSdaCountryId ?? mobileUserData.mda_sda_country_id;
        if (existingId != null && existingId !== '') {
            return Number(existingId);
        }

        const legacyName = mobileUserData.mdaSda ?? mobileUserData.mda_sda;
        if (legacyName && Array.isArray(mdaSdaList) && mdaSdaList.length > 0) {
            const match = mdaSdaList.find((item: any) => item.name === legacyName);
            return match?.id ?? null;
        }

        return null;
    }

    private getMdaSdaNameById(id: number | null | undefined): string | null {
        if (id == null) {
            return null;
        }

        const field = this.promoterForm.find((f: any) => f.formControlName === 'mdaSdaCountryId');
        const option = field?.value?.find((item: any) => item.id === id);
        return option?.name ?? null;
    }

    loadTierList(formField?: any) {
        const tierField = formField || this.promoterForm.find((f: any) => f.formControlName === 'tiers');
        if (!tierField) return;
        this.productService.tierGetAll(1, 100).subscribe(
            (res: any) => {
                const tiers = (res?.result?.result && Array.isArray(res.result.result))
                    ? res.result.result
                    : (Array.isArray(res?.result) ? res.result : []);
                tierField.value = tiers.map((tier: any) => ({ id: tier.id, name: tier.name }));
                if (this.editData?.mobileUserData?.tiers) {
                    const tierId = this.editData.mobileUserData.tiers;
                    const matchingTier = tierField.value.find((tier: any) => tier.id === tierId);
                    if (matchingTier) {
                        this.masterUserForm.patchValue({ tiers: matchingTier.id });
                    }
                }
            },
            () => {
                tierField.value = [];
            }
        );
    }

    // Method to check if all options are selected
    isAllSelected(formField: any): boolean {
        const controlValue =
            this.masterUserForm.get(formField.formControlName)?.value || [];
        return formField.value.every((item: any) => controlValue.includes(item.id));
    }

    // Method to toggle select all
    toggleSelectAll(formField: any): void {
        const control = this.masterUserForm.get(formField.formControlName);
        if (this.isAllSelected(formField)) {
            formField.allSelected = false;
            control?.setValue([]);
        } else {
            formField.allSelected = true;
            const allValues = formField.value.map((item: any) => item.id);
            control?.setValue(allValues);
        }
    }

    onOptionChange(formField: any): void {
        const controlValue =
            this.masterUserForm.get(formField.formControlName)?.value || [];
        const allSelectableIds = formField?.value
            .filter((item: any) => item.name !== noDataFound)
            .map((item: any) => item.id);
        const allSelected = allSelectableIds?.every((id: any) =>
            controlValue?.includes(id)
        );
        formField.allSelected = allSelected;
    }

    filteredOptions(formField: any): any[] {
        if (!formField.searchQuery) {
            return formField.value;
        }

        const query = formField.searchQuery.toLowerCase();
        const controlValue = this.masterUserForm.get(formField.formControlName)?.value || [];

        // Get all options that match the search query
        const filteredBySearch = formField.value.filter((option: any) => {
            const optionName = option.id ? option.name : option;
            return optionName.toLowerCase().includes(query);
        });

        // If using objects with id/name (like most dropdowns)
        if (formField.value[0]?.id) {
            // Add back any selected options that might have been filtered out by search
            const selectedOptions = formField.value.filter((option: any) =>
                Array.isArray(controlValue) ?
                    controlValue.includes(option.id) :
                    controlValue === option.id
            );

            // Combine filtered results with selected options, avoiding duplicates
            const combinedResults = [...filteredBySearch];

            // Add any selected options that weren't already in the filtered results
            selectedOptions.forEach((option: any) => {
                if (!combinedResults.some(item => item.id === option.id)) {
                    combinedResults.push(option);
                }
            });

            return combinedResults;
        }

        // For simple string arrays
        return filteredBySearch;
    }

    // Clear the search field for a specific dropdown
    clearSearch(formField: any): void {
        formField.searchQuery = '';
    }

    public checkBoxValidation(isMultiple: boolean, optionValue: any) {
        let noDatacheck = optionValue.filter(
            (val: any) => val.name === 'No Data Found'
        );
        if (isMultiple && noDatacheck[0]?.name !== 'No Data Found') {
            return true;
        } else {
            return false;
        }
    }

    public getCountryCode() {
        this.masterService.getCountryCode().subscribe((res: any) => {
            this.countryCodeData = res.result;
        });
    }
    public getLoginUserDetials(getId: any, methodFrom: string, getUserRole?: any) {
        let id = parseInt(getId != null ? getId : '');
        this.userService.getUserDetailsById(id).subscribe((res: any) => {
            const isLogin = methodFrom === 'loginUser';
            const isEdit = methodFrom === 'editUserData';

            if (isLogin || isEdit) {
                if (isLogin) {
                    this.userId = res.result.roles.map((role: any) => role.id);
                    this.userDetials = res.result.roles;
                    // Store logged-in user's roles with projectId
                    this.loggedInUserRoles = res.result.roles || [];
                    // Determine logged-in user's projectId (priority: projectId = 2, then projectId = 1)
                    const hasProjectId2 = this.loggedInUserRoles.some((role: any) => role.projectId === 2);
                    const hasProjectId1 = this.loggedInUserRoles.some((role: any) => role.projectId === 1);
                    this.loggedInUserProjectId = hasProjectId2 ? 2 : (hasProjectId1 ? 1 : null);
                    // Store logged-in user's assigned region IDs
                    this.loggedInUserRegionDetails = res.result.roles.flatMap((role: any) =>
                        role.regions?.map((region: any) => region.id) || []
                    );
                } else if (isEdit) {
                    const loginUser = JSON.parse(getUserRole || '{}');
                    this.userId = [loginUser?.id];
                    // Get logged-in user details to check their projectId
                    // 'id' parameter here is the logged-in user's ID (from storage)
                    this.userService.getUserDetailsById(id).subscribe((loginUserRes: any) => {
                        this.loggedInUserRoles = loginUserRes.result.roles || [];
                        const hasProjectId2 = this.loggedInUserRoles.some((role: any) => role.projectId === 2);
                        const hasProjectId1 = this.loggedInUserRoles.some((role: any) => role.projectId === 1);
                        this.loggedInUserProjectId = hasProjectId2 ? 2 : (hasProjectId1 ? 1 : null);
                        // Store logged-in user's assigned region IDs
                        this.loggedInUserRegionDetails = loginUserRes.result.roles.flatMap((role: any) =>
                            role.regions?.map((region: any) => region.id) || []
                        );
                        // Now get roles first, then get user being edited's details
                        // Call getAllRole and wait for it to complete before getting user details
                        const roleObservable = this.loggedInUserProjectId === 2
                            ? this.masterService.getRoleByProjectId(2)
                            : this.masterService.getRoleByLevel(this.userId[0]);

                        roleObservable.subscribe((roleRes: any) => {
                            const allRoles = roleRes.result || [];

                            if (this.loggedInUserProjectId === 2) {
                                this.userTypeValue = allRoles;
                            } else {
                                this.userTypeValue =
                                    this.filterRolesForCountryPicOrCaAnalyst(allRoles);
                                this.ensureSalesManagerInRoleOptions();
                            }

                            this.checkProjectManagementAccess();

                            // Now get user being edited details after roles are loaded
                            this.userService.getUserDetailsById(this.editData.id).subscribe((editUserRes: any) => {
                                this.setUserData(editUserRes.result);
                            });
                        });
                    });
                    return;
                }
                this.getAllRole();
            }

        });
    }

    private parseProfilePhoneNumber(full: string | null | undefined): { countryCode: string; phoneNumber: string } {
        if (full === null || full === undefined) {
            return { countryCode: '', phoneNumber: '' };
        }
        const trimmed = String(full).trim();
        if (!trimmed) {
            return { countryCode: '', phoneNumber: '' };
        }
        const dialCodes = (this.countryCodeData || [])
            .map((c: any) => c?.name)
            .filter((n: unknown) => n !== null && n !== undefined && String(n).trim() !== '')
            .map((n: unknown) => String(n).trim())
            .sort((a: string, b: string) => b.length - a.length);
        for (const code of dialCodes) {
            if (trimmed.startsWith(code)) {
                let rest = trimmed.slice(code.length).trim();
                const extraDialPrefixRegex = /^\+\d+$/;
                const restTokens = rest.split(/\s+/).filter(Boolean);
                while (restTokens.length > 1 && extraDialPrefixRegex.test(restTokens[0])) {
                    restTokens.shift();
                }
                rest = restTokens.join(' ').replace(/\s+/g, '');
                return { countryCode: code, phoneNumber: rest };
            }
        }
        const spaceIdx = trimmed.indexOf(' ');
        if (spaceIdx > 0) {
            const head = trimmed.slice(0, spaceIdx).trim();
            const tail = trimmed.slice(spaceIdx + 1).trim().replace(/\s+/g, '');
            if (head.startsWith('+')) {
                return { countryCode: head, phoneNumber: tail };
            }
        }
        return { countryCode: '', phoneNumber: trimmed.replace(/\s+/g, '') };
    }

    private async setUserData(editUserDetails: any): Promise<void> {

        try {
            if (!editUserDetails || editUserDetails.roles.length === 0) {
                this.toastr.error('No roles found for this user');
                this.isLoading = false;
                return;
            }

            if (!this.editData) return;

            this.editData = {
                ...this.editData,
                status: editUserDetails.status === true,
                email: editUserDetails.email ?? this.editData?.email,
                profile: editUserDetails.profile ?? this.editData?.profile,
                mobileUserData:
                    editUserDetails.mobileUserName ?? this.editData?.mobileUserData,
                mobileUserReportingOfficer:
                    editUserDetails.mobileUserReportingOfficer ??
                    this.editData?.mobileUserReportingOfficer,
            };

            const hasNativePmRole = (editUserDetails.roles ?? []).some(
                (role: any) => Number(role.projectId) === 2,
            );
            if (hasNativePmRole) {
                this.pmAccessOnlyMode = false;
            }

            this.masterUserForm.get('loginLastId')?.disable();
            this.masterUserForm.get('loginId')?.disable();
            this.userDetials = [...editUserDetails.roles];

            const reportingOfficerSource = editUserDetails?.mobileUserReportingOfficer ?? this.editData?.mobileUserReportingOfficer;
            const tdsIds = [
                ...(reportingOfficerSource?.map((off: any) => off.reportingOfficer?.id) || []),
                ...(Array.isArray(reportingOfficerSource?.[0]?.reportingOfficerIds)
                    ? reportingOfficerSource[0].reportingOfficerIds
                    : [])
            ].filter(Boolean);

            this.isLoading = true;

            // Load region if not loaded
            if (!this.regionValue || this.regionValue.length === 0) {
                this.getRegion();
                await firstValueFrom(timer(500));
            }

            if (!this.countryCodeData?.length) {
                try {
                    const ccRes = await firstValueFrom(this.masterService.getCountryCode());
                    this.countryCodeData = ccRes?.result || [];
                } catch {
                    this.countryCodeData = this.countryCodeData || [];
                }
            }

            const { countryCode, phoneNumber } = this.parseProfilePhoneNumber(
                editUserDetails.profile?.phoneNumber
            );

            // Check if user has project management access
            const existingPmAccess =
                (editUserDetails as any).hasProjectManagementAccess === true;
            const hasProjectManagementAccess =
                this.grantPmAccessMode && !existingPmAccess
                    ? true
                    : existingPmAccess;
            this.editPmAccessSnapshot = hasProjectManagementAccess;
            const storedPmRoleId = (editUserDetails as any).projectManagementRoleId;
            this.editPmRoleSnapshot =
                [SALES, SALES_MANAGER, SALES_DIRECTOR_GM].includes(Number(storedPmRoleId))
                    ? Number(storedPmRoleId)
                    : DEFAULT_PROJECT_MANAGEMENT_ROLE_ID;

            // Patch base form values
            const baseFormData = {
                users_type: editUserDetails.roles[0]?.id || null,
                firstName: editUserDetails.profile.firstName,
                lastName: editUserDetails.profile.lastName,
                countryCode,
                phoneNumber,
                email: editUserDetails.email,
                address: editUserDetails.profile.address,
                dob: editUserDetails.profile.dob,
                gender: editUserDetails.profile.gender,
                hasProjectManagementAccess: hasProjectManagementAccess,
                projectManagementRoleId: hasProjectManagementAccess ? this.editPmRoleSnapshot : null,
                isTestUser: (editUserDetails as any).isTestUser === true,
            };
            this.editIsTestUserSnapshot = baseFormData.isTestUser;
            this.roleSelection = editUserDetails.roles.map((val: any) => val.id);
            this.masterUserForm.get('phoneNumber')?.enable();
            this.masterUserForm.patchValue(baseFormData);

            // Skip if no role selection
            if (this.roleSelection.length === 0) return;

            const isAdmin = this.roleSelection.includes(1);

            if (isAdmin) {
                await firstValueFrom(timer(1000));
                this.onSelectionUserChange();
                return;
            }

            // Extract region & country
            const regionValue = editUserDetails.roles.flatMap((role: any) => role.regions?.map((r: any) => r.id) || []);
            const countryValue = editUserDetails.roles.flatMap((role: any) => role.countries?.map((c: any) => c.id) || []);

            if (regionValue.length === 0) {
                this.toastr.error('Region value is missing in this user');
                this.regionUpdateDataCheck = true;
                this.getRegion();
                return;
            }

            // Check if any selected role has project_id = 2
            const hasProjectId2 = this.userTypeValue.some((role: any) =>
                this.roleSelection.includes(role.id) && role.projectId === 2
            );

            const isSingleRegionSelection = LEVEL_6_GROUP_ROLES.some((r) => this.roleSelection.includes(r));
            const isPromoterOrTDS = LEVEL_3_GROUP_ROLES.some((r) => this.roleSelection.includes(r));

            // Collect forkJoin calls
            const isTdsRole = this.selectionHasTds();
            const isPromoterRole = this.roleSelection.includes(PROMOTER_ROLE_ID);
            const forkCalls = {
                countryFilter: this.getCountryFilter(regionValue).pipe(defaultIfEmpty([])),
                storeNames: countryValue.length > 0 ? this.getStoreName(countryValue).pipe(
                    tap(res => this.storeNameDetails = res.result || []),
                    defaultIfEmpty([])
                ) : of([]),
                tdsData: countryValue.length > 0
                    ? (isPromoterRole
                        ? this.getReportingOfficersForPromoter(countryValue).pipe(defaultIfEmpty(null))
                        : isSingleRegionSelection
                            ? this.getTdsByCountry(countryValue).pipe(
                                tap(res => this.tdsDetails = res.result || []),
                                defaultIfEmpty(null)
                            )
                            : of(null))
                    : of(null),
                tdlData: isTdsRole && countryValue.length > 0 ? this.getTdlByCountry(countryValue).pipe(
                    defaultIfEmpty(null)
                ) : of(null),
                mdaSdaData: isPromoterRole && countryValue.length > 0
                    ? this.loadMdaSdaCountryList(countryValue).pipe(defaultIfEmpty([]))
                    : of([]),
            };

            const results = await firstValueFrom(forkJoin(forkCalls));

            // Set up the form fields BEFORE patching values
            // This ensures the correct form (multiselect vs single select) is used
            this.onSelectionUserChange();

            // Wait a bit for form to be set up
            await firstValueFrom(timer(200));

            // Patch region and country
            // For projectId = 2, always use arrays (multiple selection)
            // For countryPIC (single selection), use single value
            const isCountryPIC = this.roleSelection.includes(COUNTRYPIC_ROLE_ID) && !hasProjectId2;

            // Ensure regionValue and countryValue are arrays and remove duplicates
            const regionArray = Array.isArray(regionValue)
                ? [...new Set(regionValue)].filter(Boolean)
                : regionValue ? [...new Set([regionValue])].filter(Boolean) : [];
            const countryArray = Array.isArray(countryValue)
                ? [...new Set(countryValue)].filter(Boolean)
                : countryValue ? [...new Set([countryValue])].filter(Boolean) : [];

            // For projectId = 2, always patch as arrays (multiselect)
            // For countryPIC, patch as single value
            // For other roles, use existing logic
            let regionPatchValue: any;
            let countryPatchValue: any;

            if (hasProjectId2) {
                // Multiple selection for projectId = 2
                regionPatchValue = regionArray;
                countryPatchValue = countryArray;
            } else if (isCountryPIC) {
                // Single selection for countryPIC
                regionPatchValue = regionArray.length > 0 ? regionArray[0] : null;
                countryPatchValue = countryArray.length > 0 ? countryArray[0] : null;
            } else {
                // Existing logic for other roles
                regionPatchValue = isSingleRegionSelection ? (regionArray.length > 0 ? regionArray[0] : null) : regionArray;
                countryPatchValue = isSingleRegionSelection ? (countryArray.length > 0 ? countryArray[0] : null) : countryArray;
            }

            this.masterUserForm.patchValue({
                regionId: regionPatchValue,
                countryId: countryPatchValue,
            });

            // If Promoter or TDS, fetch store details
            let storeIds: number[] = [];
            if (isPromoterOrTDS) {
                const userDetailRes = await firstValueFrom(this.userService.getUserDetailsById(this.editData.id));
                const storeDetails = Array.from(
                    new Map(
                        userDetailRes.result.roles
                            .flatMap((role: any) => role.stores)
                            .map((store: any) => [store.id, store])
                    ).values()
                );
                storeIds = storeDetails.map((store: any) => store.id);
                const existingUserName = this.editData?.mobileUserData?.userName ?? '';
                const loginIdData = String(existingUserName).split('@');
                const loginIdValue = (loginIdData[0] ?? '').trim();
                const loginLastIdValue = loginIdData.length > 1 && (loginIdData[1] ?? '').trim()
                    ? `@${(loginIdData[1] ?? '').trim()}`
                    : '';

                const tierValueToSet = this.editData.mobileUserData?.tiers ?? null;
                const mdaSdaList = results.mdaSdaData ?? [];
                const mdaSdaCountryIdToSet = this.resolveMdaSdaCountryId(
                    this.editData.mobileUserData,
                    mdaSdaList,
                );

                // Patch mobile-specific data
                const mobilePatch: any = {
                    ...(storeIds.length && { storeIds }),
                    ...(this.editData.mobileUserData && {
                        mdaSdaCountryId: mdaSdaCountryIdToSet,
                        basicSalary: this.editData.mobileUserData.basicSalary || null,
                        tiers: tierValueToSet,
                        incentiveSchemeTypeId: this.editData.mobileUserData?.incentiveSchemeType?.id ?? null,
                        loginId: loginIdValue || null,
                        loginLastId: loginLastIdValue || null,
                        promoterType: this.editData?.mobileUserData?.promoterCategory?.id || null,
                        joiningDate: this.parseLocalDate(this.editData?.mobileUserData?.joiningDate ?? null),
                        releasingDate: this.parseLocalDate(this.editData?.mobileUserData?.releasingDate ?? null)
                    }),
                    ...(tdsIds.length && this.roleSelection.includes(PROMOTER_ROLE_ID) && { promotertds: [...new Set(tdsIds)] }),
                    ...(tdsIds.length && this.selectionHasTds() && { tdsReportingManager: [...new Set(tdsIds)] })
                };

                this.masterUserForm.patchValue(mobilePatch);
                if (!loginLastIdValue) {
                    this.patchLoginLastIdFromCountryId(this.masterUserForm.value.countryId);
                }
            }

            if (this.roleSelection.includes(PROMOTER_ROLE_ID)) {
                const countryVal = this.masterUserForm.value.countryId;
                const promoterCountryId = Array.isArray(countryVal) ? (countryVal[0] ?? null) : countryVal;
                this.updatePromoterReportingOfficerSelectionMode(promoterCountryId);
                this.onSelectionUserChange();
            }

            // Wait a bit for form to update, then update validation
            await firstValueFrom(timer(300));
            this.updateValidationCheck(this.userDetials);
            // Role-based edit permissions for location fields only
            const canEdit = Array.isArray(this.roleSelection) && this.roleSelection.some((roleId: number) => roleId <= 6);
            if (!canEdit) {
                this.masterUserForm.get('countryId')?.disable({ emitEvent: false });
                this.masterUserForm.get('regionId')?.disable({ emitEvent: false });
            } else {
                this.masterUserForm.get('countryId')?.enable({ emitEvent: false });
                this.masterUserForm.get('regionId')?.enable({ emitEvent: false });
            }

            if (this.pmAccessOnlyMode) {
                this.applyPmAccessOnlyFieldLocks();
            } else {
                this.checkProjectManagementAccess();
            }
        } catch (error) {
            console.error('Error in setUserData:', error);
            this.toastr.error('Error loading user data');
        } finally {
            this.isLoading = false;
        }
    }

    // private setUserData(editUserDetails: any) {
    //     try {
    //         if (editUserDetails.roles.length === 0) {
    //             this.toastr.error('No roles found for this user');
    //             this.isLoading = false;
    //             return;
    //         }

    //         if (!this.editData) return;

    //         this.userDetials = [...editUserDetails.roles];
    //         const tdsIds = this.editData.mobileUserReportingOfficer?.map(
    //             (officer: any) => officer.reportingOfficer?.id
    //         ).filter((id: number) => id !== undefined) || [];

    //         if (this.editData.mobileUserReportingOfficer?.length > 0) {
    //             const reportingOfficerIds = this.editData.mobileUserReportingOfficer[0].reportingOfficerIds;
    //             if (Array.isArray(reportingOfficerIds)) {
    //                 tdsIds.push(...reportingOfficerIds);
    //             }
    //         }

    //         // Create an observable from editData
    //         return of(editUserDetails)
    //             .pipe(
    //                 tap(() => (this.isLoading = true)),
    //                 // First get region data
    //                 tap(() => {
    //                     if (!this.regionValue || this.regionValue.length === 0) {
    //                         this.getRegion();
    //                     }
    //                 }),
    //                 // Wait a bit for region data to load if needed
    //                 mergeMap(() => {
    //                     if (!this.regionValue || this.regionValue.length === 0) {
    //                         return timer(500); // Wait for region data to load
    //                     }
    //                     return of(null);
    //                 }),
    //                 map((data) => {
    //                     const phoneParts = editUserDetails.profile?.phoneNumber?.split(' ') ?? ['', ''];
    //                     const countryCode = phoneParts[0] ?? '';
    //                     const phoneNumber = phoneParts[1] ?? '';

    //                     return {
    //                         roleSelection: editUserDetails.roles.map((val: any) => val.id),
    //                         countryCode: countryCode,
    //                         basicFormData: {
    //                             users_type: editUserDetails.roles.map((val: any) => val.id),
    //                             firstName: editUserDetails.profile.firstName,
    //                             lastName: editUserDetails.profile.lastName,
    //                             countryCode: countryCode,
    //                             phoneNumber: phoneNumber,
    //                             email: editUserDetails.email,
    //                             address: editUserDetails.profile.address,
    //                             dob: editUserDetails.profile.dob,
    //                             gender: editUserDetails.profile.gender,
    //                             promotertds: tdsIds
    //                         }
    //                     }
    //                 }),
    //                 tap(({ roleSelection, basicFormData }) => {
    //                     this.roleSelection = roleSelection;
    //                     this.masterUserForm.get('phoneNumber')?.enable();
    //                     this.masterUserForm.patchValue(basicFormData);
    //                 }),
    //                 filter(() => this.roleSelection.length > 0),
    //                 mergeMap(({ roleSelection }) => {
    //                     if (!roleSelection.includes(1)) {
    //                         const regionValue = editUserDetails.roles?.flatMap((val: any) =>
    //                             val.regions ? val.regions.map((reg: any) => reg.id) : []
    //                         ) || [];

    //                         if (regionValue.length === 0) {
    //                             this.toastr.error('Region value is missing in this user');
    //                             this.regionUpdateDataCheck = true;
    //                             this.getRegion();
    //                             return EMPTY;
    //                         }

    //                         const countryValue = editUserDetails.roles?.flatMap((val: any) =>
    //                             val.countries ? val.countries.map((country: any) => country.id) : []
    //                         ) || [];
    //                         const isSingleRegionSelection = LEVEL_6_GROUP_ROLES.some((role) =>
    //                             roleSelection.includes(role)
    //                         );

    //                         const isPromoterOrTDS = LEVEL_3_GROUP_ROLES.some((role) =>
    //                             roleSelection.includes(role)
    //                         );

    //                         // First load region and country data
    //                         const apiCalls = {
    //                             countryFilter: this.getCountryFilter(regionValue).pipe(defaultIfEmpty([])),
    //                             storeNames: countryValue.length > 0 ? this.getStoreName(countryValue).pipe(
    //                                 tap(storeResult => {
    //                                     this.storeNameDetails = storeResult.result || [];
    //                                 }),
    //                                 defaultIfEmpty([])
    //                             ) : of([]),
    //                             tdsData: isSingleRegionSelection && countryValue.length > 0 ?
    //                                 this.getTdsByCountry(countryValue).pipe(
    //                                     tap(tdsResult => {
    //                                         this.tdsDetails = tdsResult.result || [];
    //                                     }),
    //                                     defaultIfEmpty(null)
    //                                 ) : of(null)
    //                         };

    //                         return forkJoin(apiCalls).pipe(
    //                             mergeMap((results) => {
    //                                 console.log('API Results:', results);
    //                                 console.log(regionValue, countryValue)

    //                                 // After region and country data is loaded, patch those values
    //                                 // const initialFormData = {

    //                                 // };
    //                                 this.masterUserForm.patchValue({
    //                                     regionId: isSingleRegionSelection ? regionValue[0] : regionValue,
    //                                     countryId: isSingleRegionSelection ? countryValue[0] : countryValue
    //                                 });

    //                                 // Load store details if needed
    //                                 if (isPromoterOrTDS) {
    //                                     return this.userService.getUserDetailsById(this.editData.id).pipe(
    //                                         map((res) => {
    //                                             const storeDetails = Array.from(
    //                                                 new Map(
    //                                                     res.result.roles
    //                                                         .flatMap((role: any) => role.stores)
    //                                                         .map((store: any) => [store.id, store])
    //                                                 ).values()
    //                                             );

    //                                             return {
    //                                                 ...results,
    //                                                 storeIds: storeDetails.map((val: any) => val.id),
    //                                                 tdsIds: [...new Set(tdsIds)]
    //                                             } as LoadResults;
    //                                         })
    //                                     );
    //                                 }
    //                                 return of(results as LoadResults);
    //                             }),
    //                             tap((finalResults: LoadResults) => {
    //                                 const mobileData: any = {};

    //                                 if (finalResults.storeIds) {
    //                                     mobileData.storeIds = finalResults.storeIds;
    //                                 }

    //                                 if (this.editData.mobileUserData) {
    //                                     mobileData.mdaSda = this.editData.mobileUserData.mdaSda || null;
    //                                     mobileData.basicSalary = this.editData.mobileUserData.basicSalary || null;
    //                                     mobileData.tiers = this.editData.mobileUserData.tiers ?
    //                                         `Tier ${this.editData.mobileUserData.tiers}` : '';
    //                                 }

    //                                 if (finalResults.tdsIds && finalResults.tdsIds.length > 0) {
    //                                     mobileData.promotertds = finalResults.tdsIds;
    //                                 }

    //                                 this.masterUserForm.patchValue(mobileData);
    //                                 this.onSelectionUserChange();
    //                                 this.updateValidationCheck(this.userDetials);
    //                             })
    //                         );
    //                     }
    //                     return timer(1000).pipe(tap(() => this.onSelectionUserChange()));
    //                 }),
    //                 finalize(() => {
    //                     this.isLoading = false;
    //                 })
    //             )
    //             .subscribe({
    //                 error: (error) => {
    //                     console.error('Error in setUserData:', error);
    //                     this.toastr.error('Error loading user data');
    //                     this.isLoading = false;
    //                 }
    //             });
    //     } catch (error) {
    //         console.error('Error in setUserData:', error);
    //         this.isLoading = false;
    //         return EMPTY;
    //     }
    // }

    /** Roles assignable by Country PIC / CA Analyst (project id 1 users + Sales Manager). */
    private filterRolesForCountryPicOrCaAnalyst(allRoles: any[]): any[] {
        const loggedInUserRoleIds = this.loggedInUserRoles.map((role: any) => role.id);
        const isAdminOrBAAdmin =
            loggedInUserRoleIds.includes(ADMIN_ROLE_ID) ||
            (loggedInUserRoleIds.includes(BA_ADMIN) || loggedInUserRoleIds.includes(SUPER_BA_ADMIN));
        const isCountryPICOrCAAnalyst =
            loggedInUserRoleIds.includes(COUNTRYPIC_ROLE_ID) ||
            loggedInUserRoleIds.includes(CA_ANALYST_ROLE_ID);

        if (isAdminOrBAAdmin) {
            return allRoles;
        }
        if (isCountryPICOrCAAnalyst) {
            return allRoles.filter(
                (role: any) => role.projectId === 1 || role.id === SALES_MANAGER,
            );
        }
        return allRoles.filter((role: any) => role.projectId === 1);
    }

    /** Sales Manager may be absent from getByLevel; always offer it for Country PIC / CA Analyst. */
    private ensureSalesManagerInRoleOptions(): void {
        const loggedInUserRoleIds = this.loggedInUserRoles.map((role: any) => role.id);
        const isCountryPICOrCAAnalyst =
            loggedInUserRoleIds.includes(COUNTRYPIC_ROLE_ID) ||
            loggedInUserRoleIds.includes(CA_ANALYST_ROLE_ID);

        if (!isCountryPICOrCAAnalyst) {
            return;
        }
        if (this.userTypeValue?.some((r: any) => r?.id === SALES_MANAGER)) {
            return;
        }
        this.userTypeValue = [
            ...(this.userTypeValue ?? []),
            { id: SALES_MANAGER, name: 'Sales Manager' },
        ];
    }

    public getAllRole() {
        const loggedInUserRoleIds = this.loggedInUserRoles.map((role: any) => role.id);
        const isCATrainer = loggedInUserRoleIds.includes(CA_TRAINER);

        if (isCATrainer) {
            // getByLevel(CA_TRAINER=17) returns level>17 (empty for IntElux mobile roles).
            // Use Country PIC level then keep Trainer/TDS/TDL/Promoter.
            this.masterService.getRoleByLevel(COUNTRYPIC_ROLE_ID).subscribe((res: any) => {
                const allRoles = res.result || [];
                this.userTypeValue = allRoles.filter((role: any) =>
                    TRAINER_TDS_TDL_PROMOTER_ROLES.includes(role.id),
                );
                this.checkProjectManagementAccess();
            });
            return;
        }

        const roleObservable = this.loggedInUserProjectId === 2
            ? this.masterService.getRoleByProjectId(2)
            : this.masterService.getRoleByLevel(this.userId[0]);

        roleObservable.subscribe((res: any) => {
            const allRoles = res.result || [];
            if (this.loggedInUserProjectId === 2) {
                this.userTypeValue = allRoles;
            } else {
                this.userTypeValue = this.filterRolesForCountryPicOrCaAnalyst(allRoles);
                this.ensureSalesManagerInRoleOptions();
            }
            this.checkProjectManagementAccess();
        });
    }

    private checkProjectManagementAccess() {
        if (this.pmAccessOnlyMode) {
            this.showProjectManagementToggle = true;
            if (
                this.editData &&
                this.editPmAccessSnapshot !== null &&
                !this.masterUserForm.get('hasProjectManagementAccess')?.dirty
            ) {
                this.masterUserForm.patchValue({
                    hasProjectManagementAccess: this.editPmAccessSnapshot,
                    projectManagementRoleId: this.editPmAccessSnapshot
                        ? this.editPmRoleSnapshot
                        : null,
                });
            }
            this.syncProjectManagementRoleControl();
            return;
        }

        // Default: hide toggle
        this.showProjectManagementToggle = false;

        // Only reset to false when creating a new user
        if (!this.editData) {
            this.masterUserForm.patchValue({
                hasProjectManagementAccess: false,
                projectManagementRoleId: null,
            });
        }

        // Check if logged-in user has Admin (role ID 1) or BA Admin (role ID 2) roles
        const loggedInUserRoleIds = this.loggedInUserRoles.map((role: any) => role.id);
        const isAdminOrBAAdmin = loggedInUserRoleIds.includes(ADMIN_ROLE_ID) || (loggedInUserRoleIds.includes(BA_ADMIN) || loggedInUserRoleIds.includes(SUPER_BA_ADMIN));
        const isCountryPICOrCAAnalyst =
            loggedInUserRoleIds.includes(COUNTRYPIC_ROLE_ID) ||
            loggedInUserRoleIds.includes(CA_ANALYST_ROLE_ID);

        // Only proceed if logged-in user is Admin/BA Admin OR Country PIC/CA Analyst
        if (!isAdminOrBAAdmin && !isCountryPICOrCAAnalyst) {
            return;
        }

        // Only proceed if there are selected roles
        if (!this.roleSelection || this.roleSelection.length === 0) {
            return;
        }

        // Country PIC / CA Analyst: PM toggle only when editing Sales Manager and logged-in user has PM.
        if (!isAdminOrBAAdmin && isCountryPICOrCAAnalyst) {
            const loggedInHasPm =
                typeof localStorage !== 'undefined' &&
                localStorage.getItem('IsProjectManagement') === 'true';

            if (this.roleSelection.includes(SALES_MANAGER) && loggedInHasPm) {
                this.showProjectManagementToggle = true;
                if (
                    this.editData &&
                    this.editPmAccessSnapshot !== null &&
                    !this.masterUserForm.get('hasProjectManagementAccess')?.dirty
                ) {
                    this.masterUserForm.patchValue({
                        hasProjectManagementAccess: this.editPmAccessSnapshot,
                        projectManagementRoleId: this.editPmAccessSnapshot
                            ? this.editPmRoleSnapshot
                            : null,
                    });
                }
            } else {
                if (!this.editData || !this.roleSelection.includes(SALES_MANAGER)) {
                    this.masterUserForm.patchValue({
                        hasProjectManagementAccess: false,
                        projectManagementRoleId: null,
                    });
                }
            }
            this.syncProjectManagementRoleControl();
            return;
        }

        // Check if any selected role has project_id = 1 or project_id = 2
        const rolesWithProjectId1 = this.userTypeValue.filter((role: any) =>
            this.roleSelection.includes(role.id) && role.projectId === 1
        );

        const rolesWithProjectId2 = this.userTypeValue.filter((role: any) =>
            this.roleSelection.includes(role.id) && role.projectId === 2
        );

        // Show toggle only if:
        // 1. Logged-in user is Admin (role ID 1) or BA Admin (role ID 2)
        // 2. Selected roles have projectId = 1 or projectId = 2
        if (rolesWithProjectId1.length > 0 || rolesWithProjectId2.length > 0) {
            this.showProjectManagementToggle = true;
            // In edit mode, restore PM flag only until the user changes the toggle
            if (
                this.editData &&
                this.editPmAccessSnapshot !== null &&
                !this.masterUserForm.get('hasProjectManagementAccess')?.dirty
            ) {
                this.masterUserForm.patchValue({
                    hasProjectManagementAccess: this.editPmAccessSnapshot,
                    projectManagementRoleId: this.editPmAccessSnapshot
                        ? this.editPmRoleSnapshot
                        : null,
                });
            } else if (!this.editData) {
                this.masterUserForm.patchValue({
                    hasProjectManagementAccess: false,
                    projectManagementRoleId: null,
                });
            }
        } else if (this.editData) {
            this.masterUserForm.patchValue({
                hasProjectManagementAccess: false,
                projectManagementRoleId: null,
            });
        }
        this.syncProjectManagementRoleControl();
    }

    private isNativePmRoleSelection(): boolean {
        if (!this.roleSelection?.length || !this.userTypeValue?.length) {
            return false;
        }

        return this.roleSelection.some(
            (roleId: number) =>
                [SALES, SALES_MANAGER, SALES_DIRECTOR_GM].includes(roleId) &&
                this.userTypeValue.some(
                    (role: any) =>
                        role.id === roleId && Number(role.projectId) === 2,
                ),
        );
    }

    private resolveProjectManagementAccessForSave(formValue: boolean | null | undefined): boolean {
        if (this.isNativePmRoleSelection()) {
            return true;
        }
        if (!this.showProjectManagementToggle) {
            return false;
        }
        return formValue === true;
    }

    private isToggleBasedProjectManagementUser(): boolean {
        if (this.pmAccessOnlyMode) {
            return true;
        }
        if (!this.showProjectManagementToggle || !this.roleSelection?.length) {
            return false;
        }
        const hasProjectId2 = this.userTypeValue.some(
            (role: any) => this.roleSelection.includes(role.id) && role.projectId === 2,
        );
        return !hasProjectId2;
    }

    public get showProjectManagementRoleSelector(): boolean {
        return (
            this.isToggleBasedProjectManagementUser() &&
            this.masterUserForm?.get('hasProjectManagementAccess')?.value === true
        );
    }

    private resolveProjectManagementRoleIdForSave(
        hasAccess: boolean,
        roleId: number | null | undefined,
    ): number | undefined {
        if (this.isNativePmRoleSelection()) {
            const nativePmRoleId = this.roleSelection.find((id: number) =>
                [SALES, SALES_MANAGER, SALES_DIRECTOR_GM].includes(id),
            );
            return nativePmRoleId;
        }
        if (!hasAccess || !this.isToggleBasedProjectManagementUser()) {
            return undefined;
        }
        if ([SALES, SALES_MANAGER, SALES_DIRECTOR_GM].includes(Number(roleId))) {
            return Number(roleId);
        }
        return DEFAULT_PROJECT_MANAGEMENT_ROLE_ID;
    }

    private syncProjectManagementRoleControl(): void {
        const roleControl = this.masterUserForm?.get('projectManagementRoleId');
        if (!roleControl) {
            return;
        }

        if (!this.isToggleBasedProjectManagementUser()) {
            roleControl.clearValidators();
            roleControl.setValue(null, { emitEvent: false });
            roleControl.updateValueAndValidity({ emitEvent: false });
            return;
        }

        const hasAccess = this.masterUserForm.get('hasProjectManagementAccess')?.value === true;
        if (hasAccess) {
            roleControl.setValidators([Validators.required]);
            if (!roleControl.value) {
                roleControl.setValue(
                    this.editPmRoleSnapshot ?? DEFAULT_PROJECT_MANAGEMENT_ROLE_ID,
                    { emitEvent: false },
                );
            }
        } else {
            roleControl.clearValidators();
            roleControl.setValue(null, { emitEvent: false });
        }
        roleControl.updateValueAndValidity({ emitEvent: false });
    }

    private applyPmAccessOnlyFieldLocks(): void {
        if (!this.pmAccessOnlyMode) {
            return;
        }

        Object.keys(this.masterUserForm.controls).forEach((key) => {
            if (key !== 'hasProjectManagementAccess' && key !== 'projectManagementRoleId') {
                this.masterUserForm.get(key)?.disable({ emitEvent: false });
            }
        });

        this.showProjectManagementToggle = true;
        this.syncProjectManagementRoleControl();
    }

    private get isPmAccessOnlyFormValid(): boolean {
        const hasPmAccess =
            this.masterUserForm.get('hasProjectManagementAccess')?.value === true;
        if (!hasPmAccess) {
            return true;
        }
        const pmRoleId = this.masterUserForm.get('projectManagementRoleId')?.value;
        return [SALES, SALES_MANAGER, SALES_DIRECTOR_GM].includes(Number(pmRoleId));
    }

    private hasCountryIdSelection(countryId: unknown): boolean {
        if (countryId == null || countryId === '') {
            return false;
        }
        return Array.isArray(countryId) ? countryId.length > 0 : true;
    }

    private getTdsByCountry(countryId: number | number[]): Observable<any> {
        let tdsData = {
            roleId: TDS_ROLE_ID,
            countryIds: Array.isArray(countryId) ? countryId : [countryId],
        };
        return this.userService.getTdsByCountryId(tdsData).pipe(
            tap((res) => {
                this.tdsDetails = res.result;
            })
        );
    }

    private getReportingOfficersForPromoter(countryId: number | number[]): Observable<any[]> {
        const countryIds = Array.isArray(countryId) ? countryId : [countryId];
        return forkJoin({
            tds: this.userService.getTdsByCountryId({ roleId: TDS_ROLE_ID, countryIds }).pipe(
                map((res: any) => res?.result ?? [])
            ),
            tdl: this.userService.getTdsByCountryId({ roleId: TDL_ROLE_ID, countryIds }).pipe(
                map((res: any) => res?.result ?? [])
            ),
        }).pipe(
            map(({ tds, tdl }) => {
                const combined = [...(Array.isArray(tds) ? tds : []), ...(Array.isArray(tdl) ? tdl : [])];
                const seen = new Set<number>();
                return combined.filter((item: any) => {
                    const id = item?.id;
                    if (id == null || seen.has(id)) return false;
                    seen.add(id);
                    return true;
                });
            }),
            tap((list) => {
                this.tdsDetails = list;
            })
        );
    }

    private updatePromoterReportingOfficerSelectionMode(countryId: number | null | undefined): void {
        const promoterOfficerField = this.promoterForm.find((f: any) => f.formControlName === 'promotertds');
        if (!promoterOfficerField || countryId == null) return;

        const selectedCountry = this.managerCountryValue?.find((c: any) => c?.id === countryId);
        const isMulti = Boolean(selectedCountry?.isMultiReportingManager);
        this.isMultiReportingManagerForPromoter = isMulti;
        promoterOfficerField.multiselect = isMulti;

        const currentValue = this.masterUserForm.get('promotertds')?.value;
        if (isMulti) {
            if (currentValue == null || currentValue === '') return;
            const asArray = Array.isArray(currentValue) ? currentValue : [currentValue];
            this.masterUserForm.patchValue({ promotertds: asArray.filter((v: any) => v != null) });
        } else {
            const first = Array.isArray(currentValue) ? (currentValue[0] ?? null) : (currentValue ?? null);
            this.masterUserForm.patchValue({ promotertds: first });
        }
    }

    private normalizeIds(value: any): number[] | null {
        if (value == null || value === '') return null;
        const arr = Array.isArray(value) ? value : [value];
        const ids = arr.map((v) => Number(v)).filter((v) => !Number.isNaN(v));
        return ids.length > 0 ? ids : null;
    }

    private getTdlByCountry(countryId: number | number[]): Observable<any> {
        let tdlData = {
            roleId: TDL_ROLE_ID,
            countryIds: Array.isArray(countryId) ? countryId : [countryId],
        };
        return this.userService.getTdsByCountryId(tdlData).pipe(
            tap((res) => {
                const list = res.result || [];
                const seen = new Set<number>();
                this.tdlDetails = list.filter((item: any) => {
                    const id = item?.id;
                    if (id == null || seen.has(id)) return false;
                    seen.add(id);
                    return true;
                });
            })
        );
    }

    private getCountryFilter(selectedValue: any): Observable<any> {
        if (!selectedValue) return EMPTY;
        return this.masterService.getCountryFilter(selectedValue).pipe(
            tap((res) => {
                this.managerCountryValue = res.result;
            })
        );
    }

    private getCountryShortByCountryName(countryId: any) {
        this.masterService.getCountryShortByCountryName(countryId).subscribe((res: any) => {
            let value = res.result.toLowerCase()
            this.masterUserForm.get('loginLastId')?.enable();
            this.masterUserForm.patchValue({ loginLastId: `@elux${value}` })
            this.masterUserForm.get('loginLastId')?.disable();
        })
    }

    private patchLoginLastIdFromCountryId(countryId: any): void {
        const id = Array.isArray(countryId) ? countryId[0] : countryId;
        if (!id) return;
        this.getCountryShortByCountryName(id);
    }

    private getStoreName(countryId: number): Observable<any> {
        return this.storeService.getStoreName([countryId]).pipe(
            tap((res: any) => {
                this.storeNameDetails = res.result;
            })
        );
    }

    private toLocalDateOnlyString(date: Date | string | null | undefined): string | null {
        if (date == null) return null;
        const d = typeof date === 'string' ? new Date(date) : date;
        if (isNaN(d.getTime())) return null;
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${y}-${m}-${day}`;
    }

    private parseLocalDate(value: string | Date | null | undefined): Date | null {
        if (value == null) return null;
        if (value instanceof Date) {
            return isNaN(value.getTime()) ? null : new Date(value.getFullYear(), value.getMonth(), value.getDate());
        }
        const s = String(value).trim();
        if (!s) return null;
        const match = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (match) {
            const y = parseInt(match[1], 10);
            const m = parseInt(match[2], 10) - 1;
            const d = parseInt(match[3], 10);
            const local = new Date(y, m, d);
            return isNaN(local.getTime()) ? null : local;
        }
        const parsed = new Date(s);
        return isNaN(parsed.getTime()) ? null : new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
    }

    public getRegion() {
        const userId = this.userId[0];
        if (![COUNTRYPIC_ROLE_ID, CA_ANALYST_ROLE_ID, CA_VIEW, CA_TRAINER].includes(userId)) {
            this.masterService.getAllRegionActiveStatus().subscribe((res) => {
                let regions = res.result || [];

                // For users with projectId = 2, filter regions to only show their assigned regions
                if (this.loggedInUserProjectId === 2 && this.loggedInUserRegionDetails && this.loggedInUserRegionDetails.length > 0) {
                    regions = regions.filter((region: any) => this.loggedInUserRegionDetails.includes(region.id));
                }

                this.regionValue = regions;
                this.regionCheck = true;
                this.onSelectionUserChange();
            });
            return;
        } else {
            this.regionValue = this.userDetials.flatMap((user: any) => user.regions);
            if (userId === 6) {
                this.managerCountryValue = this.userDetials.flatMap(
                    (user: any) => user.countries
                );
            }
        }
    }

    private selectionHasTds(ids: number[] = this.roleSelection): boolean {
        return (ids ?? []).some((id) => isTdsEquivalentRole(Number(id)));
    }

    public onSelectionUserChange() {
        // Always update roleSelection from form value, even in edit mode
        // This ensures form fields update correctly when user type changes during edit
        const previousRoleSelection = [...this.roleSelection];
        const currentType = this.masterUserForm.value.users_type;
        const nextSelection: number[] = Array.isArray(currentType)
            ? currentType
            : (currentType ? [currentType] : []);

        const hierarchyRoles = [PROMOTER_ROLE_ID, TDS_ROLE_ID, TDS_EQUIVALENT_ROLE_ID, TDL_ROLE_ID];
        const previousHierarchy = previousRoleSelection.find((roleId) =>
            hierarchyRoles.includes(roleId),
        );
        const nextHierarchy = nextSelection.find((roleId) =>
            hierarchyRoles.includes(roleId),
        );

        // Promoter ↔ TDS ↔ TDL: block until reporting mappings are cleared.
        if (
            this.editData?.id &&
            previousHierarchy &&
            nextHierarchy &&
            previousHierarchy !== nextHierarchy
        ) {
            this.userService.getReportingMappingStatus(this.editData.id).subscribe({
                next: (status) => {
                    // Block only when others report to this user; clear own manager on change.
                    if (status?.asManager > 0) {
                        this.masterUserForm.patchValue(
                            { users_type: previousRoleSelection },
                            { emitEvent: false },
                        );
                        this.roleSelection = previousRoleSelection;
                        this.toastr.warning(
                            `Please remap ${status.asManager} user(s) who report to this user before changing role between Promoter, TDS, and TDL.`,
                        );
                        return;
                    }
                    this.masterUserForm.patchValue(
                        { promotertds: null, tdsReportingManager: [] },
                        { emitEvent: false },
                    );
                    this.roleSelection = nextSelection;
                    this.continueSelectionUserChange(previousRoleSelection);
                },
                error: () => {
                    this.masterUserForm.patchValue(
                        { users_type: previousRoleSelection },
                        { emitEvent: false },
                    );
                    this.roleSelection = previousRoleSelection;
                    this.toastr.error(
                        'Unable to verify reporting mappings. Role was not changed.',
                    );
                },
            });
            return;
        }

        this.roleSelection = nextSelection;
        this.continueSelectionUserChange(previousRoleSelection);
    }

    private continueSelectionUserChange(previousRoleSelection: number[]) {
        // In edit mode, only clear fields when NO remaining roles require them
        if (this.editData && previousRoleSelection.length > 0) {
            const currentIsAdmin = this.roleSelection.includes(1);
            const currentHasLevel3Roles = LEVEL_3_GROUP_ROLES.some((role) => this.roleSelection.includes(role));
            const currentHasPromoter = this.roleSelection.includes(PROMOTER_ROLE_ID);
            const previousHasPromoter = previousRoleSelection.includes(PROMOTER_ROLE_ID);

            // Check if any selected role has project_id = 2 (needed for region/country check)
            const hasProjectId2Check = this.userTypeValue.some((role: any) =>
                this.roleSelection.includes(role.id) && role.projectId === 2
            );

            // Check if any non-admin roles need region/country
            const needsRegionCountry = this.roleSelection.some((roleId: number) =>
                roleId !== 1 && [BA_ADMIN, SUPER_BA_ADMIN, BA_VIEW, CA_ANALYST_ROLE_ID, CA_VIEW, SALES, SALES_MANAGER, SALES_DIRECTOR_GM, COUNTRYPIC_ROLE_ID].includes(roleId)
            ) || hasProjectId2Check;

            // Only clear region/country if Admin is the ONLY role selected (Admin doesn't need region/country)
            // If other roles are still selected that need region/country, keep the values
            if (currentIsAdmin && this.roleSelection.length === 1 && !needsRegionCountry) {
                this.masterUserForm.patchValue({
                    regionId: null,
                    countryId: null,
                    storeIds: null,
                    promotertds: null,
                    basicSalary: null,
                    tiers: null,
                    mdaSdaCountryId: null,
                    promoterType: null
                });
            }

            // Only clear store-related fields if NO LEVEL_3_GROUP_ROLES are selected anymore
            // This ensures if user unselects Promoter but still has TDS, stores are kept
            if (!currentHasLevel3Roles) {
                const previousHasLevel3Roles = LEVEL_3_GROUP_ROLES.some((role) => previousRoleSelection.includes(role));
                if (previousHasLevel3Roles) {
                    this.masterUserForm.patchValue({
                        storeIds: null,
                        loginId: null,
                        loginLastId: null
                    });
                }
            }

            // Only clear Promoter-specific fields if Promoter role is not selected anymore
            // Other LEVEL_3_GROUP_ROLES don't need these fields
            if (!currentHasPromoter && previousHasPromoter) {
                this.masterUserForm.patchValue({
                    promotertds: null,
                    basicSalary: null,
                    tiers: null,
                    mdaSdaCountryId: null,
                    promoterType: null,
                    incentiveSchemeTypeId: null,
                    joiningDate: null,
                    releasingDate: null
                });
            }

            const currentHasTDS = this.selectionHasTds();
            const previousHasTDS = this.selectionHasTds(previousRoleSelection);
            if (!currentHasTDS && previousHasTDS) {
                this.masterUserForm.patchValue({ tdsReportingManager: [] });
            }
            if (currentHasTDS && !previousHasTDS) {
                this.masterUserForm.patchValue({ tdsReportingManager: [] });
            }

            // If switching to Promoter role, clear TDS field (will be reloaded when country is selected)
            // But only if Promoter wasn't previously selected
            if (currentHasPromoter && !previousHasPromoter) {
                this.masterUserForm.patchValue({
                    promotertds: null
                });
            }

            // Handle switching to CA Analyst or CA View from Country PIC or other roles
            const previousHasCountryPIC = previousRoleSelection.includes(COUNTRYPIC_ROLE_ID);
            const currentHasCAAnalyst = this.roleSelection.includes(CA_ANALYST_ROLE_ID);
            const currentHasCAView = this.roleSelection.includes(CA_VIEW);
            const previousHasCAAnalyst = previousRoleSelection.includes(CA_ANALYST_ROLE_ID);
            const previousHasCAView = previousRoleSelection.includes(CA_VIEW);

            // If switching to CA Analyst or CA View, ensure countries are fetched from selected regions
            if ((currentHasCAAnalyst || currentHasCAView) &&
                (!previousHasCAAnalyst && !previousHasCAView)) {
                // NO LONGER CLEAR COUNTRY ID - User can now select it
                // this.masterUserForm.patchValue({
                //     countryId: null
                // });

                // If regions are already selected, fetch countries from those regions
                const regionIds = this.masterUserForm.value.regionId;
                if (regionIds && (Array.isArray(regionIds) ? regionIds.length > 0 : regionIds)) {
                    const regionArray = Array.isArray(regionIds) ? regionIds : [regionIds];
                    this.getCountryFilter(regionArray).subscribe((res: any) => {
                        this.managerCountryValue = res.result || [];
                        // Note: Countries will be auto-assigned during save/update
                        // We don't patch countryId here because CA Analyst uses all countries from regions
                    });
                }
            }
        }

        // Check if any selected role has project_id = 1 or project_id = 2
        this.checkProjectManagementAccess();

        // Check if any selected role has project_id = 2 (declare once at method level)
        const hasProjectId2 = this.userTypeValue.some((role: any) =>
            this.roleSelection.includes(role.id) && role.projectId === 2
        );

        let roleAndUserIdcheck = !this.roleSelection.includes(1) &&
            this.roleSelection.length > 0 &&
            this.userId.length !== 0
        if (roleAndUserIdcheck) {
            if (!this.regionCheck) {
                this.getRegion()
                // For project_id = 2 roles, show region and country fields (like countryPIC)
                if (hasProjectId2 || !this.userDetials?.map((val: any) => val.id).includes(6)) {
                    this.tdsForm[0].visible = true;
                    this.promoterForm[0].visible = true;
                    this.masterUserForm.controls['regionId'].setValidators([
                        Validators.required,
                    ]);
                }


                // For project_id = 2 roles, also require country selection
                if (hasProjectId2 || ![CA_VIEW, CA_ANALYST_ROLE_ID, CA_TRAINER].some((id) => this.roleSelection.includes(id))) {
                    this.masterUserForm.controls['countryId'].setValidators([
                        Validators.required,
                    ]);
                }
            }
            if (
                this.roleSelection.includes(PROMOTER_ROLE_ID) &&
                this.hasCountryIdSelection(this.masterUserForm.value.countryId)
            ) {
                const countryVal = this.masterUserForm.value.countryId;
                const countryIds = Array.isArray(countryVal) ? countryVal : [countryVal];
                const promoterCountryId = Array.isArray(countryVal)
                    ? (countryVal[0] ?? null)
                    : countryVal;
                this.updatePromoterReportingOfficerSelectionMode(promoterCountryId);
                this.getReportingOfficersForPromoter(countryIds).subscribe(() => {
                    const promoterTdsField = this.promoterForm.find(
                        (f: any) => f.formControlName === 'promotertds',
                    );
                    if (promoterTdsField) {
                        promoterTdsField.value =
                            this.tdsDetails.length > 0
                                ? this.tdsDetails
                                : [{ id: 1, name: this.noDataFound }];
                    }
                    // After TDS/TDL data is loaded, check if we need to set selected values
                    if (this.editData?.mobileUserReportingOfficer) {
                        const selectedTdsIds = [];

                        // Get IDs from reportingOfficer objects
                        const reportingOfficerIds = this.editData.mobileUserReportingOfficer
                            .map((officer: any) => officer.reportingOfficer?.id)
                            .filter((id: number) => id !== undefined);
                        selectedTdsIds.push(...reportingOfficerIds);

                        // Get IDs from reportingOfficerIds array if it exists
                        if (this.editData.mobileUserReportingOfficer[0]?.reportingOfficerIds) {
                            const additionalIds = Array.isArray(this.editData.mobileUserReportingOfficer[0].reportingOfficerIds)
                                ? this.editData.mobileUserReportingOfficer[0].reportingOfficerIds
                                : [this.editData.mobileUserReportingOfficer[0].reportingOfficerIds];
                            selectedTdsIds.push(...additionalIds);
                        }

                        const uniqueTdsIds = [...new Set(selectedTdsIds)];
                        // console.log('Selected TDS IDs:', uniqueTdsIds);
                        // console.log('Available TDS options:', this.tdsDetails);

                        // Verify that the selected IDs exist in the TDS options
                        const validTdsIds = uniqueTdsIds.filter(id =>
                            this.tdsDetails.some(tds => tds.id === id)
                        );

                        if (validTdsIds.length > 0) {
                            this.masterUserForm.patchValue({
                                promotertds: this.isMultiReportingManagerForPromoter ? validTdsIds : validTdsIds[0]
                            });
                        }
                    }
                });
            }
            if (
                this.selectionHasTds() &&
                this.hasCountryIdSelection(this.masterUserForm.value.countryId)
            ) {
                const countryVal = this.masterUserForm.value.countryId;
                const countryIds = Array.isArray(countryVal) ? countryVal : [countryVal];
                this.getTdlByCountry(countryIds).subscribe(() => {
                    if (this.editData?.mobileUserReportingOfficer) {
                        const selectedTdlIds: number[] = [];
                        this.editData.mobileUserReportingOfficer
                            .map((officer: any) => officer.reportingOfficer?.id)
                            .filter((id: number) => id !== undefined)
                            .forEach((id: number) => selectedTdlIds.push(id));
                        if (this.editData.mobileUserReportingOfficer[0]?.reportingOfficerIds) {
                            const ids = Array.isArray(this.editData.mobileUserReportingOfficer[0].reportingOfficerIds)
                                ? this.editData.mobileUserReportingOfficer[0].reportingOfficerIds
                                : [this.editData.mobileUserReportingOfficer[0].reportingOfficerIds];
                            selectedTdlIds.push(...ids);
                        }
                        const validTdlIds = [...new Set(selectedTdlIds)].filter(id =>
                            this.tdlDetails.some((tdl: any) => tdl.id === id)
                        );
                        if (validTdlIds.length > 0) {
                            this.masterUserForm.patchValue({ tdsReportingManager: validTdlIds });
                        }
                    }
                });
            }

            if (this.regionUpdateDataCheck) {
                // For project_id = 2 roles, show region and country fields (like countryPIC)
                if (hasProjectId2 || !this.userDetials?.map((val: any) => val.id).includes(6)) {
                    this.tdsForm[0].visible = true;
                    this.promoterForm[0].visible = true;
                    this.masterUserForm.controls['regionId'].setValidators([
                        Validators.required,
                    ]);
                }


                // For project_id = 2 roles, also require country selection
                if (hasProjectId2 || ![CA_VIEW, CA_ANALYST_ROLE_ID, CA_TRAINER].some((id) => this.roleSelection.includes(id))) {
                    this.masterUserForm.controls['countryId'].setValidators([
                        Validators.required,
                    ]);
                }
            }

            if (LEVEL_3_GROUP_ROLES.some((role) => this.roleSelection.includes(role))) {
                this.masterUserForm.controls['storeIds'].setValidators([
                    Validators.required,
                ]);
                this.masterUserForm.controls['loginId'].setValidators([
                    Validators.required,
                ]);
            }
            if (this.roleSelection.includes(PROMOTER_ROLE_ID)) {
                this.masterUserForm.controls['promotertds'].setValidators([
                    Validators.required,
                ]);
                this.masterUserForm.controls['basicSalary'].setValidators([
                    Validators.required,
                ]);
            }
            if (this.selectionHasTds()) {
                this.masterUserForm.controls['tdsReportingManager'].clearValidators();
            }

        } else {
            if (!hasProjectId2 && !this.userDetials?.map((val: any) => val.id).includes(6)) {
                this.masterUserForm.controls['regionId'].clearValidators();
            }
            if (!hasProjectId2 && ![CA_VIEW, CA_ANALYST_ROLE_ID, CA_TRAINER].some((id) => this.roleSelection.includes(id))) {
                this.masterUserForm.controls['countryId'].clearValidators();
            }

            if (!LEVEL_3_GROUP_ROLES.some((role) => this.roleSelection.includes(role))) {
                this.masterUserForm.controls['storeIds'].clearValidators();
                this.masterUserForm.controls['loginId'].clearValidators();

            }
            if (!this.roleSelection.includes(PROMOTER_ROLE_ID)) {
                this.masterUserForm.controls['promotertds'].clearValidators();
                this.masterUserForm.controls['basicSalary'].clearValidators();
            }
            if (!this.selectionHasTds()) {
                this.masterUserForm.controls['tdsReportingManager'].clearValidators();
            }
        }
        let activeRoleName = this.userTypeValue
            .filter((val: any) =>
                this.roleSelection.some((roleVal: any) => val.id === roleVal)
            )
            .map((val: any) => val.name)
            .join(', ');

        if ((this.roleSelection.includes(BA_ADMIN) || this.roleSelection.includes(SUPER_BA_ADMIN))) {
            this.adminForm[0].sectionTitle = activeRoleName;
            this.adminForm[0].value =
                this.regionValue.length > 0
                    ? this.regionValue
                    : [{ id: 1, name: this.noDataFound }];
            this.adminForm[1].value =
                this.managerCountryValue.length > 0
                    ? this.managerCountryValue
                    : [{ id: 1, name: this.noDataFound }];
            this.formFieldDetails = this.adminForm;
        }
        if (this.roleSelection.includes(BA_VIEW)) {
            this.baForm[0].sectionTitle = activeRoleName;
            this.baForm[0].value =
                this.regionValue.length > 0
                    ? this.regionValue
                    : [{ id: 1, name: this.noDataFound }];
            this.baForm[1].value =
                this.managerCountryValue.length > 0
                    ? this.managerCountryValue
                    : [{ id: 1, name: this.noDataFound }];
            this.formFieldDetails = this.baForm;
        }
        if (this.roleSelection.includes(CA_VIEW)) {
            this.regionalHeadForm[0].sectionTitle = activeRoleName;
            this.regionalHeadForm[0].value =
                this.regionValue.length > 0
                    ? this.regionValue
                    : [{ id: 1, name: this.noDataFound }];
            this.regionalHeadForm[1].value =
                this.managerCountryValue.length > 0
                    ? this.managerCountryValue
                    : [{ id: 1, name: this.noDataFound }];
            this.formFieldDetails = this.regionalHeadForm;
        }
        if (this.roleSelection.includes(CA_ANALYST_ROLE_ID)) {
            this.regionalAnalystForm[0].sectionTitle = activeRoleName;
            this.regionalAnalystForm[0].value =
                this.regionValue.length > 0
                    ? this.regionValue
                    : [{ id: 1, name: this.noDataFound }];
            this.regionalAnalystForm[1].value =
                this.managerCountryValue.length > 0
                    ? this.managerCountryValue
                    : [{ id: 1, name: this.noDataFound }];
            this.formFieldDetails = this.regionalAnalystForm;
        }
        if (this.roleSelection.includes(CA_TRAINER)) {
            this.regionalHeadForm[0].sectionTitle = activeRoleName;
            this.regionalHeadForm[0].value =
                this.regionValue.length > 0
                    ? this.regionValue
                    : [{ id: 1, name: this.noDataFound }];
            this.regionalHeadForm[1].value =
                this.managerCountryValue.length > 0
                    ? this.managerCountryValue
                    : [{ id: 1, name: this.noDataFound }];
            this.formFieldDetails = this.regionalHeadForm;
        }

        // For projectId = 2, use projectManagementForm with multiselect
        if (hasProjectId2) {
            this.projectManagementForm[0].sectionTitle = activeRoleName;
            this.projectManagementForm[0].value =
                this.regionValue.length > 0
                    ? this.regionValue
                    : [{ id: 1, name: this.noDataFound }];
            this.projectManagementForm[1].value =
                this.managerCountryValue.length > 0
                    ? this.managerCountryValue
                    : [{ id: 1, name: this.noDataFound }];
            this.formFieldDetails = this.projectManagementForm;
        } else if (this.roleSelection.includes(COUNTRYPIC_ROLE_ID)) {
            this.countryPICForm[0].sectionTitle = activeRoleName;
            this.countryPICForm[0].value =
                this.regionValue.length > 0
                    ? this.regionValue
                    : [{ id: 1, name: this.noDataFound }];
            this.countryPICForm[1].value =
                this.managerCountryValue.length > 0
                    ? this.managerCountryValue
                    : [{ id: 1, name: this.noDataFound }];
            this.formFieldDetails = this.countryPICForm;
        }
        if (LEVEL_4_GROUP_ROLES.some((role) => this.roleSelection.includes(role))) {
            this.tdsForm[0].sectionTitle = activeRoleName;
            this.tdsForm[0].value = this.regionValue;
            this.tdsForm[1].value =
                this.managerCountryValue.length > 0
                    ? this.managerCountryValue
                    : [{ id: 1, name: this.noDataFound }];
            this.tdsForm[2].value =
                this.storeNameDetails.length > 0
                    ? this.storeNameDetails
                    : [{ id: 1, name: this.noDataFound }];
            const tdsReportingManagerField = this.tdsForm.find((f: any) => f.formControlName === 'tdsReportingManager');
            if (tdsReportingManagerField) {
                tdsReportingManagerField.visible = this.selectionHasTds();
                tdsReportingManagerField.value = this.tdlDetails.length > 0
                    ? this.tdlDetails
                    : [{ id: 1, name: this.noDataFound }];
            }
            this.formFieldDetails = this.tdsForm;

        }
        if (this.roleSelection.includes(PROMOTER_ROLE_ID)) {
            if (!this.promoterTypeValueCheck) {
                this.promoterTypeValueCheck = true
                this.getPromoterType()
            }
            const selectedCountryId = typeof this.masterUserForm.value.countryId === 'number'
                ? this.masterUserForm.value.countryId
                : (Array.isArray(this.masterUserForm.value.countryId) ? this.masterUserForm.value.countryId[0] : null);
            this.updatePromoterReportingOfficerSelectionMode(selectedCountryId);
            const tierField = this.promoterForm.find((field: any) => field.formControlName === 'tiers');
            const incentiveSchemeField = this.promoterForm.find((field: any) => field.formControlName === 'incentiveSchemeTypeId');
            if (tierField) {
                tierField.visible = true;
                if (!tierField.value || tierField.value.length === 0) {
                    this.loadTierList(tierField);
                }
            }
            if (incentiveSchemeField) {
                incentiveSchemeField.visible = true;
                this.getIncentiveSchemeTypes();
            }
            const mdaSdaField = this.promoterForm.find((field: any) => field.formControlName === 'mdaSdaCountryId');
            if (mdaSdaField && selectedCountryId) {
                mdaSdaField.visible = true;
                this.loadMdaSdaCountryList(selectedCountryId).subscribe();
            }
            this.promoterForm[0].sectionTitle = activeRoleName;
            this.promoterForm[0].value = this.regionValue;
            this.promoterForm[1].value =
                this.managerCountryValue.length > 0
                    ? this.managerCountryValue
                    : [{ id: 1, name: this.noDataFound }];
            this.promoterForm[2].value =
                this.storeNameDetails.length > 0
                    ? this.storeNameDetails
                    : [{ id: 1, name: this.noDataFound }];
            this.promoterForm[3].value =
                this.tdsDetails.length > 0
                    ? this.tdsDetails
                    : [{ id: 1, name: this.noDataFound }];
            this.formFieldDetails = this.promoterForm;

            // this.masterUserForm.controls['promotertds'].setValidators([
            //   Validators.required,
            // ]);
        } else {
            // this.masterUserForm.controls['promotertds'].clearValidators();
        }
        if (this.roleSelection.length === 0) {
            this.formFieldDetails = [];
            this.regionCheck = false;
            // Only reset form in add mode, not in edit mode
            // In edit mode, preserve user data even if all roles are unselected
            if (!this.editData) {
                this.masterUserForm.reset();
            }
        }
    }
    public shouldDisableOption(id: number): boolean {
        if (this.editData) {
            const hierarchyRoles = [PROMOTER_ROLE_ID, TDS_ROLE_ID, TDS_EQUIVALENT_ROLE_ID, TDL_ROLE_ID];
            const hasHierarchyRole = this.roleSelection.some((roleId: number) =>
                hierarchyRoles.includes(roleId)
            );
            // Promoter / TDS / TDL may switch among themselves (mappings checked on save).
            if (hasHierarchyRole) {
                return !hierarchyRoles.includes(id);
            }
            const hasFieldWorkerRole = this.roleSelection.some((roleId: number) =>
                FIELD_WORKER_GROUP_ROLES.includes(roleId)
            );
            if (hasFieldWorkerRole) {
                return true;
            }
            const adminChangeableRoles = [BA_ADMIN, SUPER_BA_ADMIN, BA_VIEW, CA_ANALYST_ROLE_ID, CA_VIEW, COUNTRYPIC_ROLE_ID];
            const hasAdminChangeableRole = this.roleSelection.some((roleId: number) =>
                adminChangeableRoles.includes(roleId)
            );
            if (hasAdminChangeableRole) {
                return !adminChangeableRoles.includes(id);
            }
            const selectedSalesRole = this.roleSelection.find((roleId: number) =>
                SALES_LEVEL_GROUP_ROLES.includes(roleId)
            );
            if (selectedSalesRole) {
                const editedRoleMeta = this.userTypeValue?.find(
                    (role: any) => role.id === selectedSalesRole,
                );
                const isNativePmSalesUser =
                    editedRoleMeta?.projectId === 2 &&
                    SALES_LEVEL_GROUP_ROLES.includes(selectedSalesRole);
                const loggedInPmEditor = this.loggedInUserProjectId === 2;

                if (loggedInPmEditor && isNativePmSalesUser) {
                    return !SALES_LEVEL_GROUP_ROLES.includes(id);
                }
                return id !== selectedSalesRole;
            }
            return false;
        }

        if (this.roleSelection.length > 0) {
            return !this.roleSelection.includes(id);
        }

        return false;
    }

    public isPromoterSelected(): boolean {
        return this.roleSelection.includes(PROMOTER_ROLE_ID);
    }

    private userForms() {
        this.masterUserForm = this.masterFB.group({
            users_type: new FormControl(null, Validators.required),
            firstName: new FormControl('', Validators.required),
            lastName: new FormControl('', Validators.required),
            countryCode: new FormControl('', Validators.required),
            phoneNumber: new FormControl('', [
                Validators.required,
                Validators.minLength(5),
                Validators.maxLength(18),
            ]),
            email: new FormControl('', [
                Validators.required,
                Validators.email,
                Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$'),
            ]),
            address: new FormControl(''),
            dob: new FormControl(''),
            gender: new FormControl('', Validators.required),
            regionId: new FormControl([]),
            countryId: new FormControl([]),
            storeIds: new FormControl([]),
            basicSalary: new FormControl(''),
            tiers: new FormControl(''),
            promotertds: new FormControl(null),
            tdsReportingManager: new FormControl([]),
            mdaSdaCountryId: new FormControl(null),
            loginId: new FormControl(''),
            loginLastId: new FormControl(''),
            promoterType: new FormControl(''),
            incentiveSchemeTypeId: new FormControl(null),
            hasProjectManagementAccess: new FormControl(false),
            projectManagementRoleId: new FormControl<number | null>(null),
            isTestUser: new FormControl(false),
            joiningDate: new FormControl(''),
            releasingDate: new FormControl(''),
        });
        this.masterUserForm.get('phoneNumber')?.disable();
        this.masterUserForm.get('loginLastId')?.disable();

        this.masterUserForm.get('hasProjectManagementAccess')?.valueChanges.subscribe(() => {
            this.syncProjectManagementRoleControl();
        });
    }
    // Character field validation
    allowOnlyCharacters(event: KeyboardEvent): void {
        this.commonService.allowOnlyLetters(event);
    }
    public loginIdMaker(event: Event, fieldname: string) {
        if (this.editData) {
            return;
        }
        let userType = this.roleSelection.some((val: any) => LEVEL_3_GROUP_ROLES.includes(val))
        if (!userType) {
            return;
        }
        const value = (event.target as HTMLInputElement).value;
        if (fieldname === 'firstName') {
            this.firstName = value;
        }
        if (fieldname === 'lastName') {
            this.lastName = value;
        }
        const first = this.firstName?.trim().replace(/\s+/g, '') || '';
        const last = this.lastName?.trim().replace(/\s+/g, '') || '';
        const finalValue = `${first}${last}`;
        this.masterUserForm.get('loginId')?.setValue(finalValue);
    }
    //phone number field validation
    allowOnlyNumber(event: any): void {
        this.commonService.allowOnlyNumber(event);
    }
    //email validation
    get f() {
        return this.masterUserForm.controls;
    }
    //After select the country code phone number field will display
    onSelectionChange(event: any, code: string): void {
        if (event.isUserInput && code != '') {
            this.masterUserForm.get('phoneNumber')?.enable();
        }
    }

    //section role title
    public dynamicRoleTitle(roleId: any) {
        if (roleId === null || roleId === undefined) return
        const roleIds = Array.isArray(roleId) ? roleId : [roleId];
        if (!roleIds.includes(1) && roleIds.length > 0) {
            let roleTitle = this.userTypeValue.filter((val: any) => roleIds.includes(val.id));
            let roleName = roleTitle.map((val: any) => val.name).join(', ');
            return roleName
        }
        return
    }

    public async onAutofetch(event: any, fieldName: string, formField: any) {
        if (formField.multiselect) {
            this.onOptionChange(formField);
        }
        if (event === undefined && fieldName !== 'tierCheck' && fieldName !== 'IncentiveSchemeType' && fieldName !== 'mdaSdaCountry') return;

        let userRegion = this.userDetials.flatMap((user: any) =>
            user.regions.map((region: any) => region.id)
        );
        try {
            switch (fieldName) {
                case 'Region':
                    let regionCountryData = await firstValueFrom(this.getCountryFilter(event));
                    this.managerCountryValue = regionCountryData.result;

                    // For CA Analyst and CA View, we no longer automatically clear countryId 
                    // since they now support manual country selection.
                    if ([CA_ANALYST_ROLE_ID, CA_VIEW, CA_TRAINER].some((roleId) => this.roleSelection.includes(roleId))) {
                        if (event.length === 0) {
                            this.masterUserForm.patchValue({
                                countryId: null
                            });
                        }
                    } else if (event.length === 0 || !userRegion.includes(event)) {
                        this.masterUserForm.patchValue({
                            countryId: null,
                            storeIds: null,
                            promotertds: null,
                            mdaSdaCountryId: null,
                        });
                    }
                    break;

                case 'countryRegion':
                    let countryData = await firstValueFrom(this.getCountryFilter(event));
                    this.managerCountryValue = countryData.result;
                    if (event.length === 0 || !userRegion.includes(event)) {
                        this.masterUserForm.patchValue({
                            countryId: null,
                            storeIds: null,
                            promotertds: null,
                            mdaSdaCountryId: null,
                        });
                    }

                    break;
                case 'IncentiveSchemeType':
                    if (!formField.value || formField.value.length === 0) {
                        this.getIncentiveSchemeTypes();
                    }
                    break;
                case 'mdaSdaCountry':
                    if (this.roleSelection.includes(PROMOTER_ROLE_ID)) {
                        const countryId = this.masterUserForm.value.countryId;
                        if (this.hasCountryIdSelection(countryId)) {
                            await firstValueFrom(this.loadMdaSdaCountryList(countryId));
                        }
                    }
                    break;
                case 'tdlByCountry':
                    if (event && (Array.isArray(event) ? event.length > 0 : typeof event === 'number')) {
                        await firstValueFrom(this.getTdlByCountry(event));
                        const tdsField = this.tdsForm.find((f: any) => f.formControlName === 'tdsReportingManager');
                        if (tdsField) tdsField.value = this.tdlDetails.length > 0 ? this.tdlDetails : [{ id: 1, name: this.noDataFound }];
                    }
                    break;
                case 'tierCheck':
                    if (!formField.value || formField.value.length === 0) {
                        this.loadTierList(formField);
                    }
                    break;
                case 'countryStore':
                    this.getCountryShortByCountryName(event)
                    this.updatePromoterReportingOfficerSelectionMode(event);
                    let storeName = await firstValueFrom(this.getStoreName(event));
                    this.storeNameDetails = storeName.result;
                    if (this.roleSelection.includes(PROMOTER_ROLE_ID)) {
                        await firstValueFrom(this.getReportingOfficersForPromoter(event));
                        await firstValueFrom(this.loadMdaSdaCountryList(event));
                    } else {
                        let tdsName = await firstValueFrom(this.getTdsByCountry(event));
                        this.tdsDetails = tdsName.result;
                    }
                    if (this.selectionHasTds()) {
                        await firstValueFrom(this.getTdlByCountry(event));
                    }
                    this.masterUserForm.patchValue({
                        storeIds: null,
                        promotertds: null,
                        tdsReportingManager: [],
                        mdaSdaCountryId: null,
                    });
                    break;
            }
            this.onSelectionUserChange();
        } catch (err) {
            console.error('Error in onAutofetch:', err);
        }
    }

    public tierCheck(tierValue: any, fieldName: string) {
        if (tierValue === '' || tierValue === null || tierValue === undefined) return;

        if (fieldName === 'tierCheck') {
            // If tierValue is a number (from API response id), use it directly
            if (typeof tierValue === 'number') {
                this.tierValue = tierValue;
            }
            // If tierValue is an object with id property (from dropdown selection)
            else if (tierValue && typeof tierValue === 'object' && tierValue.id) {
                this.tierValue = tierValue.id;
            }
            // If tierValue is a string like "Tier 1", "Tier 2", etc. (for backward compatibility)
            else if (typeof tierValue === 'string' && tierValue.startsWith('Tier ')) {
                const tierNum = parseInt(tierValue.replace('Tier ', ''));
                if (!isNaN(tierNum)) {
                    this.tierValue = tierNum;
                }
            }
        }
    }

    public async addUser() {
        try {
            this.loadingSpinner = true;
            this.masterUserForm.get('loginLastId')?.enable();
            let userFormValue = this.masterUserForm.value;
            const currentUsersType = Array.isArray(userFormValue.users_type) ? userFormValue.users_type : (userFormValue.users_type ? [userFormValue.users_type] : []);
            if (currentUsersType.length > 0 && currentUsersType.includes(PROMOTER_ROLE_ID)) {
                let loginId = userFormValue.loginId + userFormValue.loginLastId;
                this.masterService.loginIdCheck(loginId).subscribe((res: any) => {
                    if (res.result !== null) {
                        this.loadingSpinner = false;
                        this.toastr.error('Login ID already exists. Please use a different login ID.');
                        this.masterUserForm.get('loginId')?.setErrors({ 'incorrect': true });
                        return;
                    }
                });
            }
            userFormValue.tiers = this.tierValue

            // For CA_ANALYST_ROLE_ID and CA_VIEW, if countryId is empty, fetch countries from selected regions
            let countryIdsToUse = userFormValue.countryId;
            const isCARole = [CA_ANALYST_ROLE_ID, CA_VIEW, CA_TRAINER].some((roleId) => this.roleSelection.includes(roleId));
            if (isCARole) {
                // If user has NOT manually selected any countries, fallback to all countries in regions
                if (!countryIdsToUse || (Array.isArray(countryIdsToUse) && countryIdsToUse.length === 0) ||
                    (Array.isArray(countryIdsToUse) && countryIdsToUse.every((id: any) => !id || id === null))) {
                    // First try to use countries from managerCountryValue (countries for selected regions)
                    if (this.managerCountryValue && this.managerCountryValue.length > 0) {
                        countryIdsToUse = this.managerCountryValue.map((country: any) => country.id);
                    } else {
                        // If managerCountryValue is not available, fetch countries from selected regions
                        const regionIds = Array.isArray(userFormValue.regionId)
                            ? userFormValue.regionId
                            : (userFormValue.regionId ? [userFormValue.regionId] : []);

                        if (regionIds.length > 0) {
                            try {
                                const regionCountryData = await firstValueFrom(this.getCountryFilter(regionIds));
                                this.managerCountryValue = regionCountryData.result || [];
                                countryIdsToUse = this.managerCountryValue.length > 0
                                    ? this.managerCountryValue.map((country: any) => country.id)
                                    : [];
                            } catch (error) {
                                console.error('Error fetching countries from regions:', error);
                                countryIdsToUse = [];
                            }
                        } else {
                            countryIdsToUse = [];
                        }
                    }
                }
            }

            const hasPmAccess = this.resolveProjectManagementAccessForSave(
                userFormValue.hasProjectManagementAccess
            );

            const userData = {
                id: 0,
                email: userFormValue.email,
                status: true,
                isApproval: this.selectionHasTds(),
                hasProjectManagementAccess: hasPmAccess,
                projectManagementRoleId: this.resolveProjectManagementRoleIdForSave(
                    hasPmAccess,
                    userFormValue.projectManagementRoleId,
                ),
                isTestUser: userFormValue.isTestUser === true,
                mobileUserReportingOfficer: [
                    {
                        reportingOfficerIds: this.roleSelection.includes(PROMOTER_ROLE_ID)
                            ? this.normalizeIds(userFormValue?.promotertds)
                            : this.selectionHasTds()
                                ? (Array.isArray(userFormValue?.tdsReportingManager) && userFormValue.tdsReportingManager.length > 0 ? userFormValue.tdsReportingManager : null)
                                : null
                    },
                ],
                mobileUserName: {
                    userName: userFormValue.loginId + userFormValue.loginLastId || null,
                    mdaSda: this.getMdaSdaNameById(userFormValue?.mdaSdaCountryId),
                    mdaSdaCountryId: userFormValue?.mdaSdaCountryId ?? null,
                    basicSalary: userFormValue?.basicSalary || null,
                    tiers: userFormValue?.tiers || null,
                    incentiveSchemeTypeId: this.roleSelection.includes(PROMOTER_ROLE_ID) ? (userFormValue?.incentiveSchemeTypeId ?? null) : undefined,
                    promoterCategory: userFormValue?.promoterType || null,
                    joiningDate: this.toLocalDateOnlyString(userFormValue?.joiningDate) ?? userFormValue?.joiningDate ?? null,
                    releasingDate: this.toLocalDateOnlyString(userFormValue?.releasingDate) ?? userFormValue?.releasingDate ?? null,
                },
                roleAssignment: this.roleSelection.map((roleId: number) => {
                    // For CA_ANALYST_ROLE_ID and CA_VIEW, use countries from selected regions
                    let roleCountryIds: number[] = [];
                    if ([CA_ANALYST_ROLE_ID, CA_VIEW, CA_TRAINER].includes(roleId)) {
                        roleCountryIds = Array.isArray(countryIdsToUse) && countryIdsToUse.length > 0
                            ? countryIdsToUse
                            : [];
                    } else {
                        // For other roles, use countryId from form if available
                        const formCountryId = userFormValue.countryId;
                        if (Array.isArray(formCountryId) && formCountryId.length > 0) {
                            roleCountryIds = formCountryId;
                        } else if (formCountryId) {
                            roleCountryIds = [formCountryId];
                        }
                    }

                    return {
                        roleId: roleId,
                        regionIds: [BA_ADMIN, SUPER_BA_ADMIN, BA_VIEW, CA_ANALYST_ROLE_ID, CA_VIEW, SALES, SALES_MANAGER, SALES_DIRECTOR_GM, CA_TRAINER].includes(roleId) ? (Array.isArray(userFormValue.regionId)
                            ? userFormValue.regionId
                            : [userFormValue.regionId]) : null,
                        countryIds: roleCountryIds.length > 0 ? roleCountryIds : null,
                        storeIds: Array.isArray(userFormValue.storeIds)
                            ? userFormValue.storeIds
                            : [userFormValue.storeIds],
                    };
                }),
                profile: {
                    firstName: userFormValue.firstName,
                    lastName: userFormValue.lastName,
                    gender: userFormValue.gender || null,
                    address: userFormValue.address || null,
                    dob: userFormValue.dob,
                    phoneNumber: `${userFormValue.countryCode} ${userFormValue.phoneNumber}`,
                },
            };

            if (this.masterUserForm.valid) {
                this.loadingSpinner = true;
                this.masterService.saveUserData(userData).subscribe({
                    next: (res: any) => {
                        this.closeDialog('success');
                        this.loadingSpinner = false;
                        this.toastr.success('User data saved successfully');
                    },
                    error: (err: any) => {
                        const errorMessage =
                            err?.message || 'Failed to save user data. Please try again!';
                        this.toastr.error(errorMessage);
                        this.loadingSpinner = false;
                    },
                });
            } else {
                this.submitted = true;
                this.toastr.warning('All fields are mandatory!');
                this.loadingSpinner = false;
            }
        } catch (error: any) {
            console.error('Error in addUser:', error);
            this.loadingSpinner = false;
            this.toastr.error('An unexpected error occurred. Please try again.');
        }
    }

    private normalizeUserStatus(value: unknown): boolean {
        return value === true || value === 'true' || value === 'Active';
    }

    public async updateUser() {
        try {
            this.loadingSpinner = true;

            if (this.pmAccessOnlyMode) {
                this.updatePmAccessOnly();
                return;
            }

            this.masterUserForm.get('countryId')?.enable();
            this.masterUserForm.get('regionId')?.enable();
            let userFormValue = this.masterUserForm.value;
            this.tierCheck(userFormValue.tiers, 'tierCheck')
            userFormValue.tiers = this.tierValue

            // For CA roles, fallback to all countries from selected regions ONLY IF NONE SELECTED
            let countryIdsToUse = userFormValue.countryId;
            const isCARole = [CA_ANALYST_ROLE_ID, CA_VIEW, CA_TRAINER].some((roleId) => this.roleSelection.includes(roleId));
            if (isCARole) {
                // Check if user has manually selected any countries
                const hasManualSelection = countryIdsToUse && Array.isArray(countryIdsToUse) && countryIdsToUse.length > 0 &&
                    countryIdsToUse.some(id => id !== null);

                if (!hasManualSelection) {
                    // Fetch countries from selected regions
                    const regionIds = Array.isArray(userFormValue.regionId)
                        ? userFormValue.regionId
                        : (userFormValue.regionId ? [userFormValue.regionId] : []);

                    if (regionIds.length > 0) {
                        try {
                            const regionCountryData = await firstValueFrom(this.getCountryFilter(regionIds));
                            this.managerCountryValue = regionCountryData.result || [];
                            countryIdsToUse = this.managerCountryValue.length > 0
                                ? this.managerCountryValue.map((country: any) => country.id)
                                : [];
                        } catch (error: any) {
                            console.error('Error fetching countries from regions:', error);
                            countryIdsToUse = [];
                        }
                    } else {
                        countryIdsToUse = [];
                    }
                }
            }

            const hasPmAccess = this.resolveProjectManagementAccessForSave(
                userFormValue.hasProjectManagementAccess
            );

            const userData = {
                id: this.editData.id,
                email: userFormValue.email,
                status: this.normalizeUserStatus(this.editData?.status),
                hasProjectManagementAccess: hasPmAccess,
                projectManagementRoleId: this.resolveProjectManagementRoleIdForSave(
                    hasPmAccess,
                    userFormValue.projectManagementRoleId,
                ),
                isTestUser: userFormValue.isTestUser === true,
                mobileUserReportingOfficer: [
                    {
                        reportingOfficerIds: this.roleSelection.includes(PROMOTER_ROLE_ID)
                            ? this.normalizeIds(userFormValue.promotertds)
                            : this.selectionHasTds()
                                ? (Array.isArray(userFormValue.tdsReportingManager) && userFormValue.tdsReportingManager.length > 0 ? userFormValue.tdsReportingManager : null)
                                : null
                    },
                ],
                mobileUserName: (() => {
                    const mu = this.editData?.mobileUserData || {};
                    const { isPmiAllowed, is_pmi_allowed, ...rest } = mu;
                    const preservedUserName = (mu.userName ?? '').toString().trim();
                    return {
                        ...rest,
                        id: mu.id,
                        userName: preservedUserName || null,
                        mdaSda: this.getMdaSdaNameById(userFormValue.mdaSdaCountryId),
                        mdaSdaCountryId: userFormValue.mdaSdaCountryId ?? null,
                        basicSalary: userFormValue.basicSalary || null,
                        tiers: userFormValue.tiers,
                        incentiveSchemeTypeId: this.roleSelection.includes(PROMOTER_ROLE_ID)
                            ? (userFormValue?.incentiveSchemeTypeId ?? null)
                            : undefined,
                        promoterCategory: userFormValue?.promoterType || null,
                        joiningDate: this.toLocalDateOnlyString(userFormValue?.joiningDate) ?? userFormValue?.joiningDate ?? null,
                        releasingDate: this.toLocalDateOnlyString(userFormValue?.releasingDate) ?? userFormValue?.releasingDate ?? null,
                    };
                })(),
                roleAssignment: this.roleSelection.map((roleId: number) => {
                    // For CA_ANALYST_ROLE_ID and CA_VIEW, use countries from selected regions
                    let roleCountryIds: number[] = [];
                    if ([CA_ANALYST_ROLE_ID, CA_VIEW, CA_TRAINER].includes(roleId)) {
                        roleCountryIds = Array.isArray(countryIdsToUse) && countryIdsToUse.length > 0
                            ? countryIdsToUse
                            : [];
                    } else {
                        // For other roles, use countryId from form if available
                        const formCountryId = userFormValue.countryId;
                        if (Array.isArray(formCountryId) && formCountryId.length > 0) {
                            roleCountryIds = formCountryId;
                        } else if (formCountryId) {
                            roleCountryIds = [formCountryId];
                        }
                    }

                    return {
                        roleId: roleId,
                        regionIds: [BA_ADMIN, SUPER_BA_ADMIN, BA_VIEW, CA_ANALYST_ROLE_ID, CA_VIEW, SALES, SALES_MANAGER, SALES_DIRECTOR_GM, CA_TRAINER].includes(roleId) ? (Array.isArray(userFormValue.regionId)
                            ? userFormValue.regionId
                            : [userFormValue.regionId]) : null,
                        countryIds: roleCountryIds.length > 0 ? roleCountryIds : null,
                        storeIds: Array.isArray(userFormValue.storeIds)
                            ? userFormValue.storeIds
                            : [userFormValue.storeIds],
                    };
                }),
                profile: {
                    firstName: userFormValue.firstName,
                    lastName: userFormValue.lastName,
                    gender: userFormValue.gender || null,
                    address: userFormValue.address || null,
                    dob: userFormValue.dob,
                    phoneNumber: `${userFormValue.countryCode} ${userFormValue.phoneNumber}`,
                },
            };
            if (!this.masterUserForm.valid) {
                this.submitted = true;
                this.toastr.warning('All fields are mandatory!');
                this.loadingSpinner = false;
                return;
            }

            let deleteSurveyRecords: boolean | undefined;
            if (userData.isTestUser !== this.editIsTestUserSnapshot) {
                this.loadingSpinner = false;
                const choice = await firstValueFrom(
                    askTestSurveyRecordsAction(this.matDialog, userData.isTestUser)
                );
                if (choice === null) {
                    return;
                }
                deleteSurveyRecords = choice;
                this.loadingSpinner = true;
            }

            const payload = deleteSurveyRecords === undefined
                ? userData
                : { ...userData, deleteSurveyRecords };
            this.masterService.updateUserData(payload).subscribe({
                next: () => {
                    this.closeDialog('success');
                    this.loadingSpinner = false;
                    this.toastr.success('User data updated successfully');
                },
                error: (err: any) => {
                    const errorMessage =
                        err?.message || 'Failed to update user data. Please try again!';
                    this.toastr.error(errorMessage);
                    this.loadingSpinner = false;
                },
            });
        } catch (error: any) {
            console.error('Error in updateUser:', error);
            this.loadingSpinner = false;
            this.toastr.error('An unexpected error occurred. Please try again.');
        }
    }

    private updatePmAccessOnly(): void {
        const userFormValue = this.masterUserForm.getRawValue();
        const hasPmAccess = this.resolveProjectManagementAccessForSave(
            userFormValue.hasProjectManagementAccess,
        );

        if (hasPmAccess && !this.isPmAccessOnlyFormValid) {
            this.submitted = true;
            this.toastr.warning('Please select a PM role when access is enabled.');
            this.loadingSpinner = false;
            return;
        }

        const pmRoleId = this.resolveProjectManagementRoleIdForSave(
            hasPmAccess,
            userFormValue.projectManagementRoleId,
        );

        this.userService
            .updateProjectManagementAccess(
                this.editData.id,
                hasPmAccess,
                hasPmAccess ? pmRoleId : undefined,
            )
            .subscribe({
                next: () => {
                    this.closeDialog('success');
                    this.loadingSpinner = false;
                    this.toastr.success(
                        hasPmAccess
                            ? this.embeddedInline
                                ? 'PM access saved successfully'
                                : 'PM access updated successfully'
                            : 'PM access removed successfully',
                    );
                },
                error: (err: any) => {
                    const errorMessage =
                        err?.message || 'Failed to update PM access. Please try again!';
                    this.toastr.error(errorMessage);
                    this.loadingSpinner = false;
                },
            });
    }

    public updateValidationCheck(userDetails: any) {
        try {
            const reportingOfficerSource = this.editData?.mobileUserReportingOfficer || [];
            const updatedTdsIds = reportingOfficerSource
                .map((officer: any) => officer?.reportingOfficer?.id)
                .filter(Boolean);

            if (this.roleSelection.includes(PROMOTER_ROLE_ID)) {
                const isTdsValuePresent = this.tdsDetails.some((tds: any) => updatedTdsIds.includes(tds.id));
                if (!isTdsValuePresent) {
                    this.masterUserForm.patchValue({ promotertds: null });
                }
            }
            if (this.selectionHasTds()) {
                const validTdlIds = updatedTdsIds.filter((id: number) => this.tdlDetails.some((tdl: any) => tdl.id === id));
                if (validTdlIds.length === 0) {
                    this.masterUserForm.patchValue({ tdsReportingManager: [] });
                }
            }

            let validCheck = userDetails.map((val: any) => {
                // let regionCheck = val.regions.map((region: any) => {
                //   console.log(this.regionValue);

                //   return this.regionValue.find((allRegion: any) => allRegion.id === region.id)
                // })
                let countrycheck = val.countries.map((country: any) => {
                    return this.managerCountryValue.find((manageCountry: any) => manageCountry.id === country.id)
                })
                let storeCheck = val.stores.map((store: any) => {
                    return this.storeNameDetails.find((stores: any) => stores.id === store.id)
                })
                if (countrycheck.length === 0) {
                    this.masterUserForm.patchValue({
                        countryId: null,

                    });
                }
                // if (regionCheck.length === 0) {
                //   this.masterUserForm.patchValue({
                //     regionId: null,

                //   });
                // }
                if (storeCheck.length === 0) {
                    this.masterUserForm.patchValue({
                        storeIds: null,
                    });
                }
            })
        } catch (error) {

            console.error('Error in updateValidationCheck:', error);
            this.toastr.error('Error validating user data');
        }
    }

    public closeDialog(val?: string) {
        this.dialogRef.close({ message: val === 'success' ? 'User added successfully' : 'User addition canceled', success: val === 'success' ? true : false });
    }

    // Add this validation method
    private validateFormData(data: any): boolean {
        return !!(data.regionId && data.countryId); // Add more validation as needed
    }
}

